import React from "react";

import * as Schemas from "./jobState_Schemas";
import { API_BASE } from "../AppConfig";
import { setNull, fetchTimeout, get, toNumber, RemoveItemFromArray, getItemFromArray } from "../components/Common";
import * as ReducerFunctions from "./reducerFunctions";
import * as CONFIG from "./configState";
import * as COMMON from "../components/Common";
import { SITE_PARAMETER_SECTIONS, QUOTE_PARAMETER_SECTIONS, BASIC_SPECS_SECTIONS } from "./jobState_Schemas";
import * as JOBSTATE_VALIDATION from "./jobState_Validation";
import _merge from "lodash/merge";
import _cloneDeep from "lodash/cloneDeep";
import { GetColourUpdateString, GetBOMUpdateString } from "../components_designer/layout/PaperFunctionHelper";
import { GetDesignStringShort } from "../components_designer/main_drawer/QuotePage";
import { updateAPP, checkInternetConnection, UPDATE_DESIGNER, SHOW_LOADING_BAR, showDialogData } from "./appState";
import { GetShapeUpdateString } from "../components_designer/layout/PaperFunctionHelper";
import { jobStateErrorPopups } from "./jobStateWarningPopups";
const { convertJobStateToIni } = require("../components/Common_Conversions");

// 2D Designer Actions
export const SHOW_DESIGNER_MESSAGE = "SHOW_DESIGNER_MESSAGE";
export const CLEAR_DESIGNER_MESSAGE = "CLEAR_DESIGNER_MESSAGE";
export const APPEND_DESIGNER_MESSAGE = "APPEND_DESIGNER_MESSAGE";

// Action Constants
export const UPDATE_2D_DESIGNER_SVGS = "UPDATE_2D_DESIGNER_SVGS";
export const UPDATE_3D_MODEL = "UPDATE_3D_MODEL";
export const UPDATE_3D_GLB = "UPDATE_3D_GLB";
export const UPDATE_CUSTOMER = "Customer";
export const UPDATE_DISTRIBUTOR = "Distributor";
export const UPDATE_DESIGN_SPECIFICATION = "UPDATE_DESIGN_SPECIFICATION";
export const UPDATE_SITE_PARAMETERS = "SiteParameters";
export const UPDATE_AREA_SPECIFICATION = "AreaSpecifications";
export const UPDATE_QUOTE_PARAMETERS = "QuoteParameters";
export const UPDATE_DESIGN_PARAMETERS = "DesignParameters";
export const UPDATE_JOB_PARAMETERS = "JobParameters";
export const ADD_NOTE = "ADD_NOTE";
export const ADD_JOB_NOTE = "ADD_JOB_NOTE";
export const ADD_NEW_AREA = "ADD_NEW_AREA";
export const ADD_NEW_AREA_TO_START = "ADD_NEW_AREA_TO_START";
export const DELETE_AREA = "DELETE_AREA";
export const NEW_JOB = "NEW_JOB";
export const UPDATE_JOB = "UPDATE_JOB";
export const UPDATE_ERROR_MAP = "UPDATE_ERROR_MAP";
export const CLEAR_ERROR_MAP = "CLEAR_ERROR_MAP";
export const UPDATE_AREA_SPECIFICATION_ERROR_MAP = "UPDATE_AREA_SPECIFICATION_ERROR_MAP";
export const UPDATE_ENGINEERING = "UPDATE_ENGINEERING";
// Combined Initial State

export const initialState = {};
export function newDefaultJobState(config, new_id = "", user_data = null, num_areas = 1) {
    const default_state = {
        id: new_id,
        UserID: user_data ? user_data.id : "",
        BusinessCode: user_data ? user_data.BusinessCode : "",
        UserCode: user_data ? user_data.Usercode : "",
        Status: "Design",
        OrderStatus: "",
        DesignSummary: "",
        Customer: Schemas.customer_initialState,
        User: {
            id: user_data?.id ? user_data.id : "",
            BusinessCode: user_data?.BusinessCode ? user_data.BusinessCode : "",
            Email: user_data?.Email ? user_data.Email : "",
            Phone: user_data?.Phone ? user_data.Phone : "",
            FirstName: user_data?.FirstName ? user_data.FirstName : "",
            LastName: user_data?.LastName ? user_data.LastName : "",
        },
        Distributor: user_data ? { ...user_data.BusinessDetails } : "",
        App: {
            current_SVG: "",
            current_OBJ: "",
        },
        QuoteParameters: Schemas.quote_parameters_initialState,
        SiteParameters: Schemas.site_parameters_initialState,
        DesignParameters: Schemas.design_parameters_initialState,
        AreaSpecifications: [Schemas.basic_specs_initialState],
        Notes: [],
    };

    while (default_state.AreaSpecifications.length < num_areas) {
        let default_area_data = _cloneDeep(Schemas.basic_specs_initialState);
        if (config?.design_options?.["Gable Hip Roof"]?.allow_roll_top_ridge)
            default_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RollTopRidge = true;
        default_state.AreaSpecifications.push(default_area_data);
    }

    let new_state = default_state;
    if (config?.id) {
        new_state = JOBSTATE_VALIDATION.validateFullJob(config, default_state);
    }

    let errorMapDefaultScheme = { ...setNull(new_state) };

    errorMapDefaultScheme.Customer.JobName = "Job Name is required";
    errorMapDefaultScheme.SiteParameters.Address.FormattedAddress = "Site Address is required";

    if (user_data)
        new_state.LastEditor = {
            id: user_data.id,
            DisplayName: user_data.DisplayName,
            UserCode: user_data.UserCode,
            _session_id: window?.session_id,
            _ts: Date.now(),
        };

    return {
        ...new_state,
        ErrorMap: errorMapDefaultScheme,
        Notes: [],
    };
}

export default function (state = initialState, action) {
    let section = action.type;
    let new_state;
    switch (action.type) {
        case NEW_JOB:
            window.job = action.parameter;

            return action.parameter;

        case UPDATE_2D_DESIGNER_SVGS:
            return {
                ...state,
                App: {
                    ...state.App,
                    current_SVG: action.value,
                },
            };
        case UPDATE_3D_MODEL:
            return {
                ...state,
                App: {
                    ...state.App,
                    current_OBJ: action.value,
                },
            };
        case UPDATE_3D_GLB:
            return {
                ...state,
                App: {
                    ...state.App,
                    current_GLB: action.value,
                },
            };
        case ADD_NOTE:
            return {
                ...state,
                Notes: [
                    ...state.Notes,
                    {
                        timestamp: action.timestamp,
                        system_generated: action.system_generated,
                        user: action.user.id,
                        user_code: action.user.UserCode,
                        user_role: action.user.RoleName,
                        text: action.value,
                        attachments: action.attachments,
                    },
                ],
            };
        case ADD_JOB_NOTE:
            return {
                ...state,
                JobNotes: [
                    ...(state.JobNotes || []),
                    {
                        timestamp: action.value.timestamp,
                        userId: action.value.userId,
                        userCode: action.value.userCode,
                        userName: action.value.userName,
                        text: action.value.text,
                    },
                ],
            };
        case ADD_NEW_AREA:
            let areaSpecs = [...state.AreaSpecifications];
            areaSpecs.push(action.value);
            new_state = {
                ...state,
                AreaSpecifications: [...areaSpecs],
            };
            if (action.config) return JOBSTATE_VALIDATION.validateFullJob(action.config, new_state);
            else return new_state;
        case ADD_NEW_AREA_TO_START:
            let areaSpecsNew = [...state.AreaSpecifications];
            areaSpecsNew.unshift(action.value);
            new_state = {
                ...state,
                AreaSpecifications: [...areaSpecsNew],
            };
            if (action.config) return JOBSTATE_VALIDATION.validateFullJob(action.config, new_state);
            else return new_state;
        case DELETE_AREA:
            let deletedAreaSpecsNew = [...state.AreaSpecifications];
            deletedAreaSpecsNew.splice(Math.floor(action.areaIndex), 1);
            new_state = {
                ...state,
                AreaSpecifications: [...deletedAreaSpecsNew],
            };
            if (action.config) return JOBSTATE_VALIDATION.validateFullJob(action.config, new_state);
            else return new_state;
        case UPDATE_DISTRIBUTOR:
            new_state = {
                ...state,
                Distributor: action.value,
            };
            if (action.config) return JOBSTATE_VALIDATION.validateFullJob(action.config, new_state);
            else return new_state;
        case UPDATE_JOB_PARAMETERS:
            if (!state) return state;

            if (!action.parameter && typeof action.value === "object") {
                new_state = {
                    ...state,
                    ...action.value,
                };
            } else {
                new_state = {
                    ...state,
                    [action.parameter]: action.value,
                };
            }
            if (action.config) return JOBSTATE_VALIDATION.validateFullJob(action.config, new_state);
            else return new_state;

        case UPDATE_CUSTOMER:
        case UPDATE_SITE_PARAMETERS:
        case UPDATE_QUOTE_PARAMETERS:
            if (!state) return state;

            if (!action.subsection) {
                let new_state = {
                    ...state,
                    [section]: {
                        ...state[section],
                        [action.parameter]: action.value,
                    },
                };
                if (action.config) return JOBSTATE_VALIDATION.validateFullJob(action.config, new_state);
                else return new_state;
            } else {
                let new_state = {
                    ...state,
                    [section]: {
                        ...state[section],
                        [action.subsection]: {
                            ...state[section][action.subsection],
                            [action.parameter]: action.value,
                        },
                    },
                };
                if (action.config) return JOBSTATE_VALIDATION.validateFullJob(action.config, new_state);
                else return new_state;
            }

        case UPDATE_DESIGN_PARAMETERS:
            section = action.type;

            if (!state) return state;

            if (!action.subsection) {
                let new_state = {
                    ...state,
                    [section]: {
                        ...state[section],
                        [action.parameter]: action.value,
                    },
                };
                if (action.config) return JOBSTATE_VALIDATION.validateFullJob(action.config, new_state);
                else return new_state;
            } else {
                let new_state = {
                    ...state,
                    [section]: {
                        ...state[section],
                        [action.subsection]: {
                            ...state[section][action.subsection],
                            [action.parameter]: action.value,
                        },
                    },
                };
                if (action.config) return JOBSTATE_VALIDATION.validateFullJob(action.config, new_state);
                else return new_state;
            }

        case UPDATE_DESIGN_SPECIFICATION:
            return {
                ...state,
                design_parameters: {
                    ...state.design_parameters,
                    [action.parameter]: action.value,
                },
            };
        case UPDATE_AREA_SPECIFICATION:
            section = action.type;

            let newAreaSpecifications = ReducerFunctions.UpdateObjectInArray(state[section], action);

            for (let index in newAreaSpecifications) {
                newAreaSpecifications[Number(index)].AreaIndex = Number(index);
            }

            let new_job = {
                ...state,
                [section]: newAreaSpecifications,
            };

            new_job.DesignSummary = GetDesignStringShort(new_job.AreaSpecifications);
            if (action.config) {
                new_job = JOBSTATE_VALIDATION.validateFullJob(action.config, new_job);
            }

            return new_job;

        case UPDATE_AREA_SPECIFICATION_ERROR_MAP:
            section = "AreaSpecifications";
            let error_action = {
                ...action,
                value: action.error,
            };

            if (!state.ErrorMap) {
                state.ErrorMap = Object.assign({}, newDefaultJobState.ErrorMap);
            }

            let new_job2 = {
                ...state,
                [section]: ReducerFunctions.UpdateObjectInArray(state[section], action),
                ErrorMap: {
                    ...state.ErrorMap,
                    [section]: ReducerFunctions.UpdateObjectInArray(state.ErrorMap[section], error_action),
                },
            };

            new_job2.DesignSummary = GetDesignStringShort(new_job2.AreaSpecifications);
            return new_job2;

        case CLEAR_ERROR_MAP:
            return {
                ...state,
                ErrorMap: setNull(state.ErrorMap),
            };

        case UPDATE_ERROR_MAP:
            if (!state.ErrorMap) {
                state.ErrorMap = Object.assign({}, newDefaultJobState.ErrorMap);
            }

            if (!action.section) {
                return {
                    ...state,
                    ErrorMap: action.value,
                };
            } else if (!action.subsection) {
                return {
                    ...state,
                    ErrorMap: {
                        ...state.ErrorMap,
                        [action.section]: {
                            ...state.ErrorMap[action.section],
                            [action.parameter]: action.value,
                        },
                    },
                };
            } else {
                return {
                    ...state,
                    ErrorMap: {
                        ...state?.ErrorMap,
                        [action.section]: {
                            ...state?.["ErrorMap"]?.[action.section],
                            [action.subsection]: {
                                ...state?.["ErrorMap"]?.[action.section]?.[action.subsection],
                                [action.parameter]: action.value,
                            },
                        },
                    },
                };
            }

        case UPDATE_ENGINEERING:
            let new_eng_data = [...state.QuoteParameters.ENGINEERING.Data];
            new_eng_data[action.areaIndex] = action.value;
            new_state = {
                ...state,
                ["QuoteParameters"]: {
                    ...state["QuoteParameters"],
                    ["ENGINEERING"]: {
                        ...state["QuoteParameters"]["ENGINEERING"],
                        ["Data"]: new_eng_data,
                    },
                },
            };
            return new_state;

        default:
            return state;
    }
}

export const addNote =
    (system_generated, user, note, attachments = null) =>
    (dispatch) => {
        dispatch({
            type: ADD_NOTE,
            timestamp: new Date().getTime(),
            system_generated: system_generated,
            user: user,
            value: note,
            attachments: attachments,
        });
    };

const MatchUpColourSelections = ({ new_area_data, area_to_match }) => {
    new_area_data.BEAMS_AND_POSTS.BeamCol1 = area_to_match.BEAMS_AND_POSTS.BeamCol1;
    new_area_data.BEAMS_AND_POSTS.Beam1ColourSelectionMade = area_to_match.BEAMS_AND_POSTS.Beam1ColourSelectionMade;
    new_area_data.BEAMS_AND_POSTS.BeamColMatchBeam = area_to_match.BEAMS_AND_POSTS.BeamColMatchBeam;
    new_area_data.BEAMS_AND_POSTS.BeamCol2 = area_to_match.BEAMS_AND_POSTS.BeamCol2;
    new_area_data.BEAMS_AND_POSTS.BeamCol2MatchBeam = area_to_match.BEAMS_AND_POSTS.BeamCol2MatchBeam;
    new_area_data.BEAMS_AND_POSTS.BeamCol3 = area_to_match.BEAMS_AND_POSTS.BeamCol3;
    new_area_data.BEAMS_AND_POSTS.BeamCol3MatchBeam = area_to_match.BEAMS_AND_POSTS.BeamCol3MatchBeam;
    new_area_data.BEAMS_AND_POSTS.BeamCol4 = area_to_match.BEAMS_AND_POSTS.BeamCol4;
    new_area_data.BEAMS_AND_POSTS.BeamCol4MatchBeam = area_to_match.BEAMS_AND_POSTS.BeamCol4MatchBeam;
    new_area_data.BEAMS_AND_POSTS.PostCol = area_to_match.BEAMS_AND_POSTS.PostCol;
    new_area_data.BEAMS_AND_POSTS.PostColourSelectionMade = area_to_match.BEAMS_AND_POSTS.PostColourSelectionMade;
    new_area_data.BEAMS_AND_POSTS.PostColMatchBeam = area_to_match.BEAMS_AND_POSTS.PostColMatchBeam;
    new_area_data.BEAMS_AND_POSTS.FootingType = area_to_match.BEAMS_AND_POSTS.FootingType;
    new_area_data.BEAMS_AND_POSTS.IntermediatePostsFullHeight =
        area_to_match.BEAMS_AND_POSTS.IntermediatePostsFullHeight;
    new_area_data.BEAMS_AND_POSTS.CornerPostsFullHeight = area_to_match.BEAMS_AND_POSTS.CornerPostsFullHeight;

    new_area_data.ROOF_SHEETING.RoofColourSelectionMade = area_to_match.ROOF_SHEETING.RoofColourSelectionMade;
    new_area_data.ROOF_SHEETING.RoofSheetColour = area_to_match.ROOF_SHEETING.RoofSheetColour;
    new_area_data.ROOF_SHEETING.SkylightColourSelectionMade = area_to_match.ROOF_SHEETING.SkylightColourSelectionMade;
    new_area_data.ROOF_SHEETING.SkylightColour = area_to_match.ROOF_SHEETING.SkylightColour;
    new_area_data.ROOF_SHEETING.FlashingColourMatchString = area_to_match.ROOF_SHEETING.FlashingColourMatchString;
    new_area_data.ROOF_SHEETING.FlashingColour = area_to_match.ROOF_SHEETING.FlashingColour;
    new_area_data.ROOF_SHEETING.RidgeColour = area_to_match.ROOF_SHEETING.RidgeColour;
    new_area_data.ROOF_SHEETING.RidgeColourMatchString = area_to_match.ROOF_SHEETING.RidgeColourMatchString;

    new_area_data.GUTTERS_AND_DOWNPIPES.GutterColourSelectionMade =
        area_to_match.GUTTERS_AND_DOWNPIPES.GutterColourSelectionMade;
    new_area_data.GUTTERS_AND_DOWNPIPES.GutterCol = area_to_match.GUTTERS_AND_DOWNPIPES.GutterCol;
    new_area_data.GUTTERS_AND_DOWNPIPES.BoxGutterColour = area_to_match.GUTTERS_AND_DOWNPIPES.BoxGutterColour;
    new_area_data.GUTTERS_AND_DOWNPIPES.BoxGutterColourMatchBeam =
        area_to_match.GUTTERS_AND_DOWNPIPES.BoxGutterColourMatchBeam;
    new_area_data.GUTTERS_AND_DOWNPIPES.DownpipeCol = area_to_match.GUTTERS_AND_DOWNPIPES.DownpipeCol;
    new_area_data.GUTTERS_AND_DOWNPIPES.DownpipeColourSelectionMade =
        area_to_match.GUTTERS_AND_DOWNPIPES.DownpipeColourSelectionMade;

    return new_area_data;
};

const MatchUpShape = ({ new_area_data, area_to_match }, roofType) => {
    const { SHAPE } = area_to_match;
    const { CUTOUTS, AREAJOIN, ...rest } = SHAPE; // Exclude Cutouts and Areajoin parameters

    new_area_data.SHAPE = { ...new_area_data.SHAPE, ...rest };

    if (!roofType) new_area_data.SHAPE.DesignType = "Flat Roof"; // Set to default - flat

    // If adding area from gable to flat set roofpitch to minimum
    if (SHAPE.DesignType !== new_area_data.SHAPE.DesignType)
        new_area_data.SHAPE.RoofPitch = new_area_data?.ROOF_SHEETING?.RoofSheetData?.min_pitch;

    return new_area_data;
};

const MatchUpSpec = ({ new_area_data, area_to_match, area_spec }) => {
    const matchedArea = area_to_match[area_spec];
    new_area_data[area_spec] = { ...matchedArea };
    return new_area_data;
};

const MatchUpRoofsheet = ({ new_area_data, area_to_match }) => {
    return MatchUpSpec({ new_area_data, area_to_match, area_spec: "ROOF_SHEETING" });
};

const MatchUpAttachments = ({ new_area_data, area_to_match }) => {
    return MatchUpSpec({ new_area_data, area_to_match, area_spec: "ATTACHMENTS" });
};

const MatchUpBeamPost = ({ new_area_data, area_to_match }) => {
    return MatchUpSpec({ new_area_data, area_to_match, area_spec: "BEAMS_AND_POSTS" });
};

const MatchUpGutterDownpipe = ({ new_area_data, area_to_match }) => {
    return MatchUpSpec({ new_area_data, area_to_match, area_spec: "GUTTERS_AND_DOWNPIPES" });
};

export const addNewArea =
    (add_to_start = false, areaSettings) =>
    (dispatch, getState) => {
        const config = getState().config;
        const AreaSpecifications = [...getState().job.AreaSpecifications];

        let new_area_data = { ...Schemas.basic_specs_initialState };

        const InheritAreaIndex = add_to_start ? 0 : AreaSpecifications.length > 0 ? AreaSpecifications.length - 1 : 0;

        if (config?.design_options?.["Gable Hip Roof"]?.allow_roll_top_ridge)
            new_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RollTopRidge = true;

        const areaData = { new_area_data, area_to_match: AreaSpecifications[InheritAreaIndex] };

        new_area_data = MatchUpColourSelections(areaData);
        if (areaSettings?.areaShape !== false) new_area_data = MatchUpShape(areaData, areaSettings?.roofType);
        if (areaSettings?.areaRoofsheet !== false) new_area_data = MatchUpRoofsheet(areaData);
        if (areaSettings?.areaAttachments !== false) new_area_data = MatchUpAttachments(areaData);
        if (areaSettings?.areaBeamPost !== false) new_area_data = MatchUpBeamPost(areaData);
        if (areaSettings?.areaGutterDownpipe !== false) new_area_data = MatchUpGutterDownpipe(areaData);

        dispatch({
            type: add_to_start ? ADD_NEW_AREA_TO_START : ADD_NEW_AREA,
            value: new_area_data,
            config: getState().config,
        });
    };

export const deleteArea = (areaIndex) => (dispatch, getState) => {
    dispatch({
        type: DELETE_AREA,
        areaIndex: areaIndex,
        value: { ...Schemas.basic_specs_initialState },
        config: getState().config,
    });
};

export const updateDistributor = (value, validate = false) => {
    return updateJobState(UPDATE_DISTRIBUTOR, null, value, validate);
};

export const updateJobUser = (value, validate = false) => {
    return updateJobState("User", null, value, validate);
};

export const updateCustomer = (parameter, value, validate = false) => {
    return updateJobState(UPDATE_CUSTOMER, parameter, value, validate);
};

export const updateSiteParameters = (parameter, value, validate = false) => {
    return updateJobState(UPDATE_SITE_PARAMETERS, parameter, value, validate);
};

export const updateJobNotes = (value) => {
    return updateJobState(ADD_JOB_NOTE, null, value, false);
};

export const updateQuoteParameters = (parameter, value, validate = false) => {
    return updateJobState(UPDATE_QUOTE_PARAMETERS, parameter, value, validate);
};

export const updateDesignParameters = (parameter, value, validate = false) => {
    return updateJobState(UPDATE_DESIGN_PARAMETERS, parameter, value, validate);
};

export const updateBOMOrderData =
    (order_data, system_data = null) =>
    (dispatch, getState) => {
        let new_bom_data = { ...getState().job.QuoteParameters.BOM };
        if (order_data !== null) new_bom_data.OrderList = order_data;
        if (system_data !== null) new_bom_data.SystemList = system_data;

        return dispatch(updateJobState(UPDATE_QUOTE_PARAMETERS, "BOM", new_bom_data, false));
    };

export const updateBOMFreightPOA = (price) => (dispatch, getState) => {
    let new_bom_data = { ...getState().job.QuoteParameters.BOM };
    new_bom_data.FreightPOA = price;
    return dispatch(updateJobState(UPDATE_QUOTE_PARAMETERS, "BOM", new_bom_data, false));
};

export const updateBOMOrderDataToCustomerOrder = (filename) => (dispatch, getState) => {
    let job = { ...getState().job };
    let api_url = API_BASE() + "document/" + job.id + "/order_file_" + encodeURI(filename);

    return fetchTimeout(
        api_url,
        {
            method: "GET",
        },
        20000
    )
        .then((response) => response.json())
        .then((json) => {
            if (json.Error) {
                throw json.Error;
            } else {
                if (json?.OrderList) {
                    let new_bom_data = { ...getState().job.QuoteParameters.BOM };
                    new_bom_data.OrderList = json?.OrderList;

                    dispatch(updateJobParameter(null, { LastBomAction: "RELOADED_FROM_FILE: " + filename }));
                    return dispatch(updateJobState(UPDATE_QUOTE_PARAMETERS, "BOM", new_bom_data, false));
                }
            }
        })
        .catch((e) => {
            dispatch({
                type: SHOW_DESIGNER_MESSAGE,
                message: "Error: Customer Order List Not Found On Server",
            });
        });
};

export const getPastOrderLists = () => (dispatch, getState) => {
    const { id, QuoteParameters } = getState().job;
    const apiUrl = `${API_BASE()}document/${id}/order_file_past_list`;

    return fetchTimeout(apiUrl, { method: "GET" }, 20000)
        .then(async (response) => {
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            return response.json();
        })
        .then((json) => {
            if (json?.Error) {
                throw new Error(json.Error);
            }

            if (!Array.isArray(json?.PastOrderLists)) {
                throw new Error("Invalid response: PastOrderLists is not an array.");
            }

            const fileNames = json.PastOrderLists.map((o) => o?.fileName).filter(Boolean);

            const newBomData = {
                ...QuoteParameters.BOM,
                PastOrderLists: fileNames,
            };

            return dispatch(updateJobState(UPDATE_QUOTE_PARAMETERS, "BOM", newBomData, false));
        })
        .catch((e) => {
            dispatch({
                type: SHOW_DESIGNER_MESSAGE,
                message: "Error: Customer Order List Not Found On Server",
            });
        });
};

const toBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

export const updateGLB = (glb) => (dispatch, getState) => {
    let job = getState()?.job;
    if (!job) return;

    toBase64(glb.files["model.glb"]).then((e) => {
        let api_url = API_BASE() + "obj/" + job.id + "/";

        return fetchTimeout(
            api_url,
            {
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    job,
                    glb: e.split("base64,")[1],
                }),
            },
            60000
        )
            .then((response) => response.json())
            .then(() => {
                dispatch(updateJobState(UPDATE_3D_GLB, "", glb, false));
            });
    });
};

export const updateBOMData =
    (job_data, fast = true, callback) =>
    async (dispatch, getState) => {
        let api_base = API_BASE(false, process?.env?.REACT_APP_LOCAL_CAD === "true");

        let api_url = api_base + "bom/generate/" + job_data.id + "/";
        let config = getState().config;
        let pricefile = getState().app?.pricefile;
        let job_ini = convertJobStateToIni(job_data, getState().app, "", getState().config);
        let request_id = Date.now();
        let job_shape_details = {};
        let offering_bom_schema = {};
        const designTemplateName = job_data?.AreaSpecifications[0]?.SHAPE?.DesignTemplateName;

        window.loadingBOM_id = request_id;
        offering_bom_schema.overall = config?.bom_items_for_each_job;

        for (let this_area_data of job_data.AreaSpecifications) {
            if (designTemplateName) {
                offering_bom_schema[this_area_data.AreaIndex] =
                    config?.design_options?.[job_data.DesignSummary]?.design_templates?.[
                        designTemplateName
                    ]?.bom_items.add;
            } else {
                const designType = this_area_data.SHAPE.DesignType;
                const design_option = config?.design_options?.[designType];
                offering_bom_schema[this_area_data.AreaIndex] = design_option?.bom_items;
            }

            // Only required if its a gable structure for sheet modification (sheet laying rules for GS1)
            let isGable = this_area_data.SHAPE.RoofType1 === "Gable" ? true : false;
            job_shape_details[this_area_data.AreaIndex] = { isGable, SKYLIGHTS: this_area_data.SKYLIGHTS };
        }

        // Add Packing fee to BOM for Lysaght
        if (window.LYSAGHT && !offering_bom_schema.overall.some((item) => item.Code === "CONSOLHI")) {
            offering_bom_schema.overall.push({ Code: "CONSOLHI", Modifiable: false });
        }

        let append_items = appendBOMItems(job_data, pricefile);

        let timeout = 20000;
        if (job_data?.DesignParameters) {
            timeout =
                8000 +
                job_data.DesignParameters.NumFlat * 3000 +
                job_data.DesignParameters.NumGable * 4000 +
                job_data.DesignParameters.NumDeck * 3000;
        }

        try {
            const response = await fetchTimeout(
                api_url,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        job: job_ini,
                        fast: fast,
                        order_list: fast ? {} : get(job_data, "QuoteParameters.BOM.OrderList", {}),
                        request_id: request_id,
                        job_id: job_data.id,
                        job_shape_details,
                        site_poa: job_data?.App?.temp_POA
                            ? job_data?.App?.temp_POA
                            : job_data?.Distributor?.Offer?.Regions?.[0],
                        offering_bom_schema: offering_bom_schema,
                        append_items: append_items,
                    }),
                    retry: true,
                    retry_timeout: timeout * 1.5,
                    request_id: request_id,
                },
                timeout
            );

            const json = await response.json();

            if (json.request_id && toNumber(json.request_id) !== toNumber(window.loadingBOM_id)) return;

            if (json.Error) {
                throw new Error(json.Error);
            } else if (json.bom_system) {
                let new_bom_data = { ...getState().job.QuoteParameters.BOM };
                let hashcode = GetShapeUpdateString() + GetColourUpdateString() + GetBOMUpdateString();

                window.job = { ...job_data };

                new_bom_data.SystemList = json.bom_system?.system_items;
                new_bom_data.bomHashCode = hashcode;

                if (json.quote_data) {
                    new_bom_data.QuoteData = json.quote_data;
                }

                if (json?.bom_system?.quote_data) {
                    new_bom_data.QuoteData = json.bom_system.quote_data;
                }

                dispatch(updateQuoteParameters("BOM", new_bom_data));
            }

            // No errors thrown so execute callback if one has been provided
            if (callback) callback();
        } catch (e) {
            let message = "Error loading layout from QikQuote server.";
            if (typeof e === "string") message = e;
            if (typeof e.message === "string") message = e.message;
            if (e.message === "failed to fetch") message = "Error loading ... QikQuote server is not accessible.";
            dispatch({
                type: SHOW_DESIGNER_MESSAGE,
                message: "Error: " + message,
            });

            let new_bom_data = {};
            if (getState().job?.QuoteParameters?.BOM) new_bom_data = { ...getState().job?.QuoteParameters?.BOM };
            new_bom_data.error = message;
            dispatch(updateQuoteParameters("BOM", new_bom_data));
        }
    };

export const appendBOMItems = (job, pricefile) => {
    let new_items = [];
    if (window.LYSAGHT && !job.DesignParameters.USE_ATTACHMENTS_2) {
        if (window?.drawing_svg_meta?.attachments) {
            for (let attachment of window?.drawing_svg_meta?.attachments) {
                let attachment_length = attachment.length;
                let attachment_type = job?.SiteParameters?.[SITE_PARAMETER_SECTIONS.ExistingStructure]?.AttachmentType;
                let sub_attachment_type = "";

                let area = attachment?.area ? attachment?.area : 0;

                const areaDataPartialAttachments = job.AreaSpecifications?.[area]?.ATTACHMENTS?.PARTIAL_ATTACHMENTS;
                if (areaDataPartialAttachments) {
                    let data_paat = getItemFromArray(areaDataPartialAttachments, "Ref", attachment.ref2);
                    if (data_paat) {
                        attachment_length = data_paat?.Length;
                    }
                }

                const areaDataAttachmentModifications =
                    job.AreaSpecifications?.[area]?.ATTACHMENTS?.AttachmentModifications;
                if (areaDataAttachmentModifications) {
                    let data_mods = getItemFromArray(areaDataAttachmentModifications, "Ref", attachment.ref2);
                    if (data_mods?.AttachmentType) {
                        attachment_type = data_mods?.AttachmentType;
                    }
                    if (data_mods?.AttachmentSubType) {
                        sub_attachment_type = data_mods?.AttachmentSubType;
                    }
                }

                if (attachment_type === "Wall") {
                    if (sub_attachment_type === "Timber Wall") {
                        new_items.push(
                            getItem(
                                pricefile,
                                "CS7510G",
                                toNumber(area) + 1,
                                attachment_length / 600 + 1,
                                "",
                                "",
                                "Wall Attachment Fix"
                            )
                        ); // coach screw
                    } else if (sub_attachment_type === "Timber Wall On Beam") {
                        new_items.push(
                            getItem(
                                pricefile,
                                "CS7510G",
                                toNumber(area) + 1,
                                attachment_length / 600 + 1,
                                "",
                                "",
                                "Wall Attachment Fix"
                            )
                        ); // coach screw

                        let beam_type = job.AreaSpecifications[area][BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2;
                        let beam_col = job.AreaSpecifications[area][BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamCol2;

                        let beam_code = "BS100";
                        if (beam_type === "FL15015") beam_code = "BS150";
                        if (beam_type === "FL20015") beam_code = "BS200";

                        new_items.push(
                            getItem(
                                pricefile,
                                beam_code,
                                toNumber(area) + 1,
                                1,
                                attachment_length + 200,
                                beam_col,
                                "Timber Wall Attachment Beam"
                            )
                        ); // beam

                        let endcap = "FLUB100";
                        if (beam_type === "FL15015") endcap = "FLUB150";
                        if (beam_type === "FL20015") endcap = "FLUB200";

                        new_items.push(getItem(pricefile, endcap, toNumber(area) + 1, 2, "", beam_col)); // beam end cap
                    } else if (sub_attachment_type === "Masonry Wall") {
                        new_items.push(
                            getItem(
                                pricefile,
                                "SA7510G",
                                toNumber(area) + 1,
                                attachment_length / 600 + 1,
                                "",
                                "",
                                "Wall Masonry Fix"
                            )
                        ); // masonary screw
                    } else if (sub_attachment_type === "Masonry Wall On Beam") {
                        new_items.push(
                            getItem(
                                pricefile,
                                "SA7510G",
                                toNumber(area) + 1,
                                attachment_length / 600 + 1,
                                "",
                                "",
                                "Wall Masonry Fix"
                            )
                        ); // masonary screw

                        let beam_type = job.AreaSpecifications[area][BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2;
                        let beam_col = job.AreaSpecifications[area][BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamCol2;

                        let beam_code = "BS100";
                        if (beam_type === "FL15015") beam_code = "BS150";
                        if (beam_type === "FL20015") beam_code = "BS200";

                        new_items.push(
                            getItem(
                                pricefile,
                                beam_code,
                                toNumber(area) + 1,
                                1,
                                attachment_length + 200,
                                beam_col,
                                "Masonry Wall Attachment Beam"
                            )
                        ); // beam

                        let endcap = "FLUB100";
                        if (beam_type === "FL15015") endcap = "FLUB150";
                        if (beam_type === "FL20015") endcap = "FLUB200";
                        new_items.push(getItem(pricefile, endcap, toNumber(area) + 1, 2, "", beam_col)); // beam end cap
                    }
                }
            }
        }

        if (window?.drawing_svg_meta?.area_data) {
            let frame = job?.SiteParameters?.[SITE_PARAMETER_SECTIONS.ExistingStructure]?.FrameType;

            for (let area_num in window?.drawing_svg_meta?.area_data) {
                let data = window?.drawing_svg_meta?.area_data[area_num];
                if (data?.num_beam_to_wall_attachments) {
                    if (frame.includes("Brick") || frame.includes("Masonry")) {
                        new_items.push(
                            getItem(
                                pricefile,
                                "SA7510G",
                                toNumber(area_num) + 1,
                                2 * data?.num_beam_to_wall_attachments,
                                "",
                                "",
                                "Bracket to Masonry Fix"
                            )
                        ); // two dynabolts
                    } else {
                        new_items.push(
                            getItem(
                                pricefile,
                                "CS7510G",
                                toNumber(area_num) + 1,
                                2 * data?.num_beam_to_wall_attachments,
                                "",
                                "",
                                "Bracket to Wall Fix"
                            )
                        ); // two coach screws
                    }
                }
            }
        }
    }

    for (let this_area_data of job.AreaSpecifications) {
        if (this_area_data.ROOF_SHEETING?.DownlightData) {
            if (
                this_area_data.ROOF_SHEETING?.DownlightData?.DownlightSelection &&
                this_area_data.ROOF_SHEETING?.DownlightData?.DownlightSelection !== "None"
            )
                new_items.push(
                    getItem(
                        pricefile,
                        this_area_data.ROOF_SHEETING?.DownlightData?.DownlightSelection,
                        this_area_data.AreaIndex + 1,
                        this_area_data.ROOF_SHEETING?.DownlightData?.Amount,
                        "",
                        this_area_data.ROOF_SHEETING?.DownlightData?.DownlightColour
                    )
                );
        }
        if (
            this_area_data.ROOF_SHEETING?.FanBracketSelection &&
            toNumber(this_area_data.ROOF_SHEETING?.FanBrackets) > 0
        ) {
            new_items.push(
                getItem(
                    pricefile,
                    this_area_data.ROOF_SHEETING?.FanBracketSelection,
                    this_area_data.AreaIndex + 1,
                    this_area_data.ROOF_SHEETING?.FanBrackets,
                    "",
                    ""
                )
            );
        }
    }

    return new_items;
};

// Get Index of item using description matching
const getIndexFromDesc = (desc, pricefile) => {
    let obj = pricefile.data.find((o) => o.ProductDescription === desc);

    if (obj) return obj.ProductIndex;
    else return "";
};

const getItem = (pricefile, index, area, qty = "1", length = "", colour = "", use = null) => {
    let obj;
    if (pricefile) obj = pricefile.data.find((o) => o.ProductIndex === index);

    if (!obj && !obj?.GroupingName) {
        index = "MSJ-" + index;
    }

    return {
        Add: true,
        Category: obj?.GroupingName ? obj.GroupingName.toUpperCase() : "",
        Code: index,
        Desc:
            (obj?.ProductDescription ? obj.ProductDescription : "****** Product Not Found:") + " <via temp adjustment>",
        Use: use ? use : "Attachment Fix",
        Colour: colour,
        Area: area,
        Qty: Math.trunc(qty).toString(),
        Length: length,
        CodeBase: index,
        CodeAppend: "",
        DescAppend: " <via temp adjustment>",
        "CL ID": "",
        Fielders_Code: obj?.ProductCode ? obj.ProductCode : "",
        "CL DATA": {
            0: null,
        },
        "CL HEADERS": "",
        Locked: false,
        SubTotalCost: null,
        UnitCost: null,
        Unit: obj?.SellingUOM ? obj.SellingUOM : "EA",
        MarkupFactor: null,
        AncillaryParts: obj?.AncillaryParts ? obj.AncillaryParts : null,
        PromptCodes: "",
        Image_b64: null,
        PromptTextCodes: obj?.PromptTextCodes ? obj.PromptTextCodes : "",
        Children: null,
        "Parent Item": "",
        ExtraData: null,
        Conditions: null,
        FixedItemLength: null,
        CuttingData: {
            0: null,
        },
    };
};

export const updateWindDataParameters = (wind_data) => (dispatch, getState) => {
    let job = { ...getState().job };

    if (job?.SiteParameters?.WindData) {
        if (wind_data?.critical === null) {
            dispatch(updateSiteParameters("WindData.WindZone_UseAS1170", false));
            dispatch(updateSiteParameters("WindData.WindZoneAS1170", null));
            Promise.resolve("OK");
        } else {
            dispatch(updateSiteParameters("WindData.WindZone_UseAS1170", true));
            dispatch(updateSiteParameters("WindData.WindZoneAS1170", wind_data, true));
            return Promise.resolve("OK");
        }
    }

    return Promise.resolve("Error");
};

export const getWindData = (in_address, vr_mode, abortSignal) => (dispatch, getState) => {
    let job = { ...getState().job };
    let app = { ...getState().app };
    let round_down_wz = { ...getState().config?.job_settings?.round_down_wz };

    let api_url = API_BASE() + "revolutio/";

    let address = in_address ? in_address : job.SiteParameters.Address;

    let height = job?.DesignParameters?.AverageRoofHeight || 4000;

    // as the engineering at 2.4m is valid up to 5m, anything under 4.5m we send 2.4m to reduce calls to the server
    if (height < 4000) height = 4000;

    let post_data = {
        lat: address.LatLng.lat,
        lng: address.LatLng.lng,
        height: height,
        address: address.FormattedAddress,
        post_code: address.PostCode,
        user_email: app.user.Email,
    };

    return fetchTimeout(
        api_url,
        {
            body: JSON.stringify(post_data),
            signal: abortSignal,
        },
        120000
    )
        .then((response) => {
            if (!response) {
                throw new Error("Invalid or empty response");
            } else if (response.status === 429) {
                throw new Error("Too Many Requests");
            } else if (!response.ok) {
                throw new Error("Invalid or empty response");
            }
            return response.json();
        })
        .then((json) => {
            if (json.Error) {
                throw new Error(json.Error);
            } else if (json.critical) {
                let new_wind_data = { ...json };

                if (new_wind_data.critical) {
                    new_wind_data.calculated = JOBSTATE_VALIDATION.calculate_wind_data(
                        new_wind_data,
                        vr_mode,
                        round_down_wz
                    );
                }

                dispatch(updateWindDataParameters(new_wind_data));

                return Promise.resolve(new_wind_data);
            } else {
                throw new Error("no Data");
            }
        })
        .catch((error) => {
            if (!error) {
                return Promise.reject(new Error("Unknown error occurred"));
            }

            if (error instanceof DOMException && error.name === "AbortError") {
                return Promise.reject(new Error("Request was aborted"));
            }

            let message = "Error loading Wind Data from QikQuote server.";
            if (error.message === "failed to fetch") {
                message = "Error loading ... QikQuote server is not accessible.";
            } else if (error instanceof Error) {
                // message = error.message;
                return Promise.reject(error);
            }

            return Promise.resolve("Error: " + message);
        });
};

export const uploadDocument =
    (document_type, document_name, document_data, resizeImageByMaxWidth = 0) =>
    (dispatch, getState) => {
        let job = { ...getState().job };
        let api_url = API_BASE() + "document/" + job.id + "/" + document_type;

        return fetchTimeout(
            api_url,
            {
                method: "PUT",
                body: JSON.stringify({
                    document_type: document_type,
                    base_64: true,
                    document_name: document_name,
                    document_data: document_data,
                    recompressImage: true,
                    resizeImageByMaxWidth: resizeImageByMaxWidth,
                }),
            },
            60000
        )
            .then((response) => response.json())
            .then((json) => {
                if (json.Error) {
                    throw json.Error;
                } else if (json.document_filename) {
                    setTimeout(function () {
                        dispatch(updateDocument(document_type, json.document_filename));
                    }, 500);
                } else {
                }
            })
            .catch();
    };

export const updateDocument = (documentType, newDocument) => (dispatch, getState) => {
    const docs = getState().job?.QuoteParameters?.DOCUMENTS ?? {};
    const prevList = docs[documentType] ?? [];

    const newDocs = {
        ...docs,
        [documentType]: [newDocument, ...prevList],
    };

    dispatch({
        type: UPDATE_QUOTE_PARAMETERS,
        parameter: QUOTE_PARAMETER_SECTIONS.DOCUMENTS,
        subsection: null,
        value: newDocs,
        config: getState().config,
    });
};

export const updateJobStateAndValidate = (section, parameter, value) => (dispatch, getState) => {
    dispatch(updateJobState(section, parameter, value)).then((result) => {
        let config = getState().config;
        let job = JOBSTATE_VALIDATION.validateJob(getState().job, config, dispatch);

        dispatch({
            type: NEW_JOB,
            parameter: job,
        });
    });
};

export const updateJobParameter = (parameter, value) => (dispatch, getState) => {
    return new Promise((resolve) => {
        dispatch({
            type: UPDATE_JOB_PARAMETERS,
            parameter: parameter,
            subsection: null,
            value: value,
            config: getState().config,
        });
        resolve("OK");
    });
};

export const updateJobState =
    (section, parameter, value, validate = false) =>
    (dispatch, getState) => {
        if (validate) {
            dispatch(validateJobState(section, parameter, value));
        }
        let subsection = null;
        if (parameter && parameter.includes(".")) {
            let parameter_split = parameter.split(".");
            subsection = parameter_split[0];
            parameter = parameter_split[1];
        } else if (section && section.includes(".")) {
            let section_split = section.split(".");
            section = section_split[0];
            subsection = section_split[1];
        }

        return new Promise((resolve) => {
            dispatch({
                type: section,
                parameter: parameter,
                subsection: subsection,
                value: value,
                config: getState().config,
            });
            resolve("OK");
        });
    };

export const validateCustomer = (parameter, value) => {
    validateJobState(UPDATE_CUSTOMER, parameter, value);
};

export const validateSiteParameters = (parameter, value) => {
    return validateJobState(UPDATE_SITE_PARAMETERS, parameter, value);
};

export const checkJobStateValidationSchema = (validationSchema, section, subsection, parameter, value) => {
    let error = null;
    let schema = get(validationSchema, section + (subsection ? "." + subsection : "") + "." + parameter);

    if (schema) {
        error = JOBSTATE_VALIDATION.checkValidationScheme(schema, value);
    }
    return error;
};

export const validateJobState = (section, parameter, value) => (dispatch, getState) => {
    let subsection = null;
    if (parameter.includes(".")) {
        let parameter_split = parameter.split(".");
        subsection = parameter_split[0];
        parameter = parameter_split[1];
    }

    let validationSchema = getState().config.validationSchema;

    let error = checkJobStateValidationSchema(validationSchema, section, subsection, parameter, value);

    dispatch({
        type: UPDATE_ERROR_MAP,
        section: section,
        parameter: parameter,
        subsection: subsection,
        value: error,
    });
};

export const updateDesignSpecification = (areaIndex, section, parameter, value) => (dispatch) => {
    dispatch({
        type: UPDATE_DESIGN_SPECIFICATION,
        areaIndex: areaIndex,
        section: section,
        parameter: parameter,
        value: value,
    });
};

export const deleteBeamPostMod = (areaIndex, ref, ref2, ref4) => (dispatch, getState) => {
    let current_array = getState().job?.AreaSpecifications?.[0]?.["BEAMMODIFICATIONS"];
    let new_data_array = [...current_array];
    let tol = 60;
    new_data_array = current_array.filter((item) => {
        if (item.Area !== areaIndex) return true; // keep
        if (item["Ref2"] === ref2 && item.Area === areaIndex) return false; //delete
        if (item["Ref"] === ref && item.Area === areaIndex) return false; // delete
        if (COMMON.IsClose(item["Ref"], ref, tol * 0.66, tol)) return false; // delete
        if (COMMON.IsClose(item["Ref4"], ref4, tol * 0.66, tol)) return false; // delete
        return true; //keep
    });
    return new Promise((resolve) => {
        dispatch(updateAreaSpecification(0, "BEAMMODIFICATIONS", null, new_data_array));
        resolve("OK");
    });
};

export const deleteFromAreaSpecificationModificationArray =
    (
        areaIndex,
        section,
        ref,
        tol = 30,
        match_parameter = undefined,
        match_value = undefined,
        refKey2 = null,
        ref2 = null
    ) =>
    (dispatch, getState) => {
        let subsection = null;
        if (section && section.includes(".")) {
            let section_split = section.split(".");
            section = section_split[0];
            subsection = section_split[1];
        }

        let current_array = getState().job?.AreaSpecifications?.[areaIndex]?.[section];
        if (current_array && subsection) current_array = current_array?.[subsection];

        let current_data_array = current_array ? [...current_array] : [];

        if (tol === "closest") {
            tol = 10;
            let new_data_array = [...current_data_array];
            while (tol < 20000 && new_data_array.length === current_data_array.length) {
                new_data_array = RemoveItemFromArray(
                    current_data_array,
                    "Ref",
                    ref,
                    null,
                    null,
                    tol,
                    match_parameter,
                    match_value
                );
                tol += 500;
            }

            return new Promise((resolve) => {
                dispatch(
                    updateAreaSpecification(
                        areaIndex,
                        section + (subsection ? "." + subsection : ""),
                        null,
                        new_data_array
                    )
                );
                resolve("OK");
            });
        } else {
            let new_data_array = RemoveItemFromArray(
                current_data_array,
                "Ref",
                ref,
                refKey2,
                ref2,
                tol,
                match_parameter,
                match_value
            );

            return new Promise((resolve) => {
                dispatch(
                    updateAreaSpecification(
                        areaIndex,
                        section + (subsection ? "." + subsection : ""),
                        null,
                        new_data_array
                    )
                );
                resolve("OK");
            });
        }
    };

export const updateAreaSpecificationModificationArray =
    (areaIndex, section, ref, parameter, value, refresh_svg = true, ref2 = null, ref_key = "Ref") =>
    (dispatch, getState) => {
        let subsection = null;
        if (section && section.includes(".")) {
            let section_split = section.split(".");
            section = section_split[0];
            subsection = section_split[1];
        }

        let current_array = getState().job?.AreaSpecifications?.[areaIndex]?.[section];

        if (current_array && subsection) current_array = current_array?.[subsection];

        if (section === "BEAMMODIFICATIONS") {
            current_array = getState().job?.AreaSpecifications?.[0]?.[section];
        }

        let new_data_array = current_array ? [...current_array] : [];
        let thisModification = null;

        if (ref) {
            let twod_only = true;
            if (section === "BEAMMODIFICATIONS") {
                current_array = current_array.filter((mod) => {
                    return mod.Area === undefined || mod.Area === areaIndex;
                });
                twod_only = true;
            }

            thisModification = getItemFromArray(current_array, ref_key, ref, "Ref2", ref2, 30, 90, twod_only);
        }

        let newValue = value === "Default" ? "" : value;
        if (section === "BEAMMODIFICATIONS") {
            if (parameter === "Length" && newValue !== "") value = Number(value);
        }
        if (newValue === "" && thisModification === null) return; // no change, no mods
        else if (thisModification === null) {
            //new mod needed
            thisModification = {};
            thisModification[ref_key] = ref;

            if (section === "BEAMMODIFICATIONS") {
                let ref_split = ref.split(";");
                if (ref_split.length > 1) {
                    thisModification.P1 = ref_split[0].replaceAll("/", ",");
                    thisModification.P2 = ref_split[1].replaceAll("/", ",");
                }
            }
            if (typeof value === "object" && !parameter) thisModification = { ...thisModification, ...value };
            else thisModification[parameter] = newValue;

            if (section === "BEAMMODIFICATIONS") {
                new_data_array = RemoveItemFromArray(
                    new_data_array,
                    ref_key,
                    ref,
                    "Ref2",
                    ref2,
                    100,
                    "Area",
                    areaIndex
                );
            } else {
                new_data_array = RemoveItemFromArray(new_data_array, ref_key, ref, "Ref2", ref2);
            }

            //update Refs
            thisModification.Ref = ref;
            if (ref2) thisModification.Ref2 = ref2;

            new_data_array.push(thisModification);
        } else {
            if (typeof value === "object" && !parameter) thisModification = { ...thisModification, ...value };
            else thisModification[parameter] = newValue;

            if (section === "BEAMMODIFICATIONS") {
                new_data_array = RemoveItemFromArray(
                    new_data_array,
                    ref_key,
                    ref,
                    "Ref2",
                    ref2,
                    100,
                    "Area",
                    areaIndex
                );
            } else {
                new_data_array = RemoveItemFromArray(new_data_array, ref_key, ref, "Ref2", ref2);
            }

            //update Refs
            thisModification[ref_key] = ref;
            if (ref2) thisModification.Ref2 = ref2;

            new_data_array.push(thisModification);
        }

        dispatch(
            updateAreaSpecification(
                section === "BEAMMODIFICATIONS" ? 0 : areaIndex,
                section + (subsection ? "." + subsection : ""),
                null,
                new_data_array
            )
        );
    };

const validateMinNumberOfIntBeams = (config, areaIndex, section, subsection, parameter, value, job, dispatch) => {
    if (parameter) {
        if (subsection) job.AreaSpecifications[areaIndex][section][subsection][parameter] = value;
        else job.AreaSpecifications[areaIndex][section][parameter] = value;
    } else {
        if (subsection) job.AreaSpecifications[areaIndex][section][subsection] = value;
        else job.AreaSpecifications[areaIndex][section] = value;
    }

    let new_beam_and_post_data = JOBSTATE_VALIDATION.validateBeamPostData(config, job, areaIndex);
    dispatch({
        type: UPDATE_AREA_SPECIFICATION,
        index: areaIndex,
        section: BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
        subsection: null,
        parameter: null,
        value: new_beam_and_post_data,
        error: null,
    });

    if (subsection === "AREAJOIN") {
        //affects the next area too

        let new_next_area_beam_and_post_data = JOBSTATE_VALIDATION.validateBeamPostData(config, job, areaIndex + 1);
        dispatch({
            type: UPDATE_AREA_SPECIFICATION,
            index: areaIndex + 1,
            section: BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
            subsection: null,
            parameter: null,
            value: new_next_area_beam_and_post_data,
            error: null,
        });
    }
};

export const getWindDataLoading = ({
    newJobState,
    setWindDataLoading,
    dispatch,
    setErrorWindDataLoading,
    abortSignal,
    setWindErrorState,
    forceUpdate,
}) => {
    if (window.loadingWindData) {
        console.log("Already loading wind data, skipping new request");
        return false;
    }
    if (newJobState?.SiteParameters?.WindData?.WindZoneAS1170?.critical && !forceUpdate) return; //Already Loaded wind
    let retries = 0;

    const clearLoadingMessages = () => {
        dispatch({
            type: CLEAR_DESIGNER_MESSAGE,
            payload: [
                "Structure height changed. Wind data updating...",
                "Wind data invalid. Updating...",
                "Error getting the wind data. Trying again...",
                "wind_data_loading",
            ],
        });
    };
    const fetchData = () => {
        window.loadingWindData = true;

        let newState = { ...newJobState };

        setWindDataLoading(true);
        setErrorWindDataLoading(false);
        let vr_mode = newJobState?.DesignParameters?.vr_mode ? newJobState?.DesignParameters?.vr_mode : 0;

        dispatch(getWindData(newState["SiteParameters"]["Address"], vr_mode, abortSignal))
            .then((wind_data) => {
                handleWindData(wind_data, newState);
            })
            .catch((error) => {
                window.loadingWindData = false;
                if (typeof error === "string" && error.includes("Invalid")) {
                    handleError(error);
                } else if (typeof error === "string" && error.includes("Too Many Requests")) {
                    handleError(error);
                } else if (error instanceof Error) {
                    if (!(error.message === "Invalid or empty response")) {
                        handleError(error);
                    }
                } else {
                    handleError(error);
                }
            });
    };

    const handleWindData = (wind_data, newState) => {
        if (!wind_data?.critical) {
            // Handle error
            newState.SiteParameters.WindData.WindZone_UseAS1170 = false;
            newState.SiteParameters.WindData.WindZoneAS1170 = null;

            if (!wind_data.includes("Invalid or empty")) {
                if (wind_data.includes("Too Many Requests")) {
                    handleRetry(true);
                } else {
                    setErrorWindDataLoading("Failed to recieve wind data. Please try again or contact support.");
                    handleRetry();
                }
            }
            window.loadingWindData = false;
        } else {
            newState.SiteParameters.WindData.WindZone_UseAS1170 = true;
            newState.SiteParameters.WindData.WindZoneAS1170 = wind_data;
            setWindDataLoading(false);
            dispatch({
                type: SHOW_DESIGNER_MESSAGE,
                message: {
                    message: "Wind data was successfully updated",
                    type: "success",
                },
            });

            clearLoadingMessages();
            window.loadingWindData = false;
        }
    };

    const handleRetry = (extendedRetry = false) => {
        window.loadingWindData = false;
        retries++;
        if (retries < 3) {
            window.loadingWindData = true;
            // increasing the waittime before a retry (from 2secs to 16 secs), because each response takes avg 15secs to complete, hence retrying after
            //  atleast 15secs so that there is no overlap with ongoing request and avoid 429 error
            setTimeout(fetchData, extendedRetry ? 16000 : 2000);
        } else {
            setWindDataLoading(false);
            setErrorWindDataLoading("Error: Failed to recieve wind data. Please try again or contact support.");
            dispatch({
                type: SHOW_DESIGNER_MESSAGE,
                message: "Error: there was an error updating the wind data. Please try loading address again.",
            });
            clearLoadingMessages();
            window.loadingWindData = false;
        }
    };

    const handleError = (error) => {
        handleRetry();
    };

    // Initial fetch
    fetchData();
};

export const updateSiteParameterData = (subsection, parameter, value) => (dispatch, getState) => {
    let new_job = COMMON.deepCopy(getState().job);
    const config = getState().config;

    if (!subsection && !parameter) new_job.SiteParameters = value;
    else if (subsection) new_job.SiteParameters[subsection][parameter] = value;
    else new_job.SiteParameters[parameter] = value;

    if (
        !["Beam", "Riser", "Flyover"].includes(
            new_job?.SiteParameters?.[SITE_PARAMETER_SECTIONS.ExistingStructure]?.AttachmentType
        )
    )
        for (let index in new_job.AreaSpecifications) {
            if (new_job.AreaSpecifications[Number(index)].SHAPE.RoofPitch < 0) {
                return {
                    error: true,
                    title: "Reverse Fall",
                    message: [
                        <>
                            To have an attached reverse fall, the attachment type must be "Beam", "Riser" or "Flyover".
                        </>,
                    ],
                };
            }
        }

    let error = null;

    if (["Wall"].includes(new_job?.SiteParameters?.[SITE_PARAMETER_SECTIONS.ExistingStructure]?.AttachmentType)) {
        let wall_height = new_job?.SiteParameters?.[SITE_PARAMETER_SECTIONS.ExistingStructure]?.WallHeight;
        if (wall_height <= 2400) {
            new_job.SiteParameters[SITE_PARAMETER_SECTIONS.ExistingStructure].WallHeight = 4000;
            new_job.SiteParameters[SITE_PARAMETER_SECTIONS.ExistingStructure].EaveDepth = 0;
            error = {
                error: true,
                title: "Attachment Wall Height modified",
                message: [
                    <>
                        As the attachment has been set to 'Wall', attachment wall height has been set to 4000mm and Eave
                        Width has been set to 0mm.
                    </>,
                ],
            };
        }
    }
    //forced compliance/ mass settings, updates
    new_job = JOBSTATE_VALIDATION.validateFullJob(config, new_job, -1, getState().app);

    dispatch({
        type: NEW_JOB,
        parameter: new_job,
    });

    if (error) return error;
};

export const updateAreaSpecificationManual = (areaIndex, new_area_specification) => (dispatch, getState) => {
    let new_job = COMMON.deepCopy(getState().job);
    const config = getState().config;
    const app = getState().app;
    new_job.AreaSpecifications[areaIndex] = COMMON.deepCopy(new_area_specification);
    //forced compliance/ mass settings, updates
    new_job = JOBSTATE_VALIDATION.validateFullJob(config, new_job, -1, getState().app);

    dispatch({
        type: NEW_JOB,
        parameter: new_job,
    });

    let error = JOBSTATE_VALIDATION.CheckSuggestions(config, new_job, -1, app)(dispatch);

    if (error && error.error) {
        dispatch(showDialogData(error));
    }

    return new Promise((resolve) => {
        resolve("OK");
    });
};

export const updateAreaSpecificationJob =
    (areaIndex, section, subsection, parameter, value) => (dispatch, getState) => {
        let new_job = COMMON.deepCopy(getState().job);
        let new_area_data = new_job.AreaSpecifications[areaIndex];
        const config = getState().config;
        const app = getState().app;

        let isGable = new_area_data.SHAPE.RoofType1 === "Gable" ? true : false;

        if (value?.target?.value) value = value?.target?.value;

        if (!subsection && !parameter) new_area_data[section] = value;
        else if (subsection) new_area_data[section][subsection][parameter] = value;
        else new_area_data[section][parameter] = value;

        if (section === BASIC_SPECS_SECTIONS.ATTACHMENTS && parameter === "AttachmentTop" && value === 0 && !isGable) {
            new_area_data[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES].GutterB = 0;
        }

        //forced compliance/ mass settings, updates
        new_job = JOBSTATE_VALIDATION.validateFullJob(config, new_job, -1, getState().app);

        dispatch({
            type: NEW_JOB,
            parameter: new_job,
        });

        let error = JOBSTATE_VALIDATION.CheckSuggestions(config, new_job, -1, app)(dispatch);

        if (error && error.error) {
            dispatch(showDialogData(error));
        }

        return new Promise((resolve) => {
            resolve("OK");
        });
    };

const isLocked = (app, job) => {
    const UNLOCKED = app?.designer?.UNLOCKED;
    const orderStatus = (job?.OrderStatus || "").toUpperCase();
    return (orderStatus === "PENDING" || orderStatus === "ACCEPTED" || job?.App?.Locked) && !UNLOCKED;
};

export const updateAreaSpecificationShape = (areaIndex, subsection, parameter, value) => (dispatch, getState) => {
    if (isLocked(getState().app, getState().job)) return;

    let new_job = COMMON.deepCopy(getState().job);
    let last_area_data = new_job?.AreaSpecifications?.[areaIndex - 1];
    let new_area_data = new_job.AreaSpecifications[areaIndex];
    let old_area_data = getState().job.AreaSpecifications[areaIndex];
    let next_area_data = new_job?.AreaSpecifications?.[areaIndex + 1];
    const config = getState().config;

    if (value?.target?.value) {
        value = value?.target?.value;
    }

    if (!subsection && !parameter) {
        new_area_data[BASIC_SPECS_SECTIONS.SHAPE] = value;
    } else if (subsection) {
        new_area_data[BASIC_SPECS_SECTIONS.SHAPE][subsection][parameter] = value;
    } else {
        new_area_data[BASIC_SPECS_SECTIONS.SHAPE][parameter] = value;
    }

    // returnable front end errors/responsive messages
    if (parameter === "RoofPitch") {
        const disallowedReverseFallAttachmentTypes = [
            "Fascia with Receiver Channel",
            "Wall with Receiver Channel",
            "Wall",
        ];

        const isReverseFall = new_area_data?.SHAPE?.RoofPitch < 0 && new_area_data?.META?.BackState?.HasAttachment;

        if (
            isReverseFall &&
            disallowedReverseFallAttachmentTypes.includes(new_area_data?.META?.BackState?.AttachmentType)
        ) {
            return {
                error: true,
                title: "Reverse Fall Not Permitted",
                message: [
                    <>
                        A reverse fall is not permitted with attachment type{" "}
                        {new_area_data?.META?.BackState?.AttachmentType.toUpperCase()}.
                    </>,
                ],
                primaryActionText: "Set to Rafter Brackets Supporting Beam",
                primaryAction: () => {
                    let backModIndex = new_area_data.ATTACHMENTS?.AttachmentModifications.findIndex(
                        (item) => item.Name === "Back 1"
                    );
                    let newBackMod = {
                        Ref: "Back 1",
                        Name: "Back 1",
                        HasEaveWidth: 0,
                        EaveWidth: 600,
                        HasWallHeight: 0,
                        WallHeight: 2100,
                        HasFasciaType: 1,
                        AttachmentType: "Rafter Brackets supporting Beam",
                        AttachmentVariation: "Gutter",
                        FasciaType: "Beam",
                        HasBeam: 1,
                        WallOnly: 0,
                        vOffset: 100,
                        hOffset: 300,
                        NumBrackets: 0,
                        HasNumBrackets: 0,
                        AllowRSBLC: 0,
                        AttachmentHOffset: 0,
                    };

                    if (backModIndex !== -1) {
                        new_area_data.ATTACHMENTS.AttachmentModifications[backModIndex] = newBackMod;
                    }

                    new_job.AreaSpecifications[areaIndex] = new_area_data;
                    new_job = JOBSTATE_VALIDATION.validateFullJob(config, new_job, -1, getState().app);

                    dispatch({
                        type: NEW_JOB,
                        parameter: new_job,
                    });
                },
                secondaryActionText: "Cancel",
                secondaryAction: null,
            };
        }
    }

    if (
        last_area_data &&
        (last_area_data.SHAPE.AREAJOIN.JoinType === "Hip" || last_area_data.SHAPE.AREAJOIN.JoinType === "Gable")
    ) {
        if (new_area_data.SHAPE.DesignSubType === "Projection" || last_area_data.SHAPE.DesignSubType === "Projection") {
            return {
                error: true,
                title: "Portal Hip/Gable Junction",
                message: [
                    <>
                        Portal Hip/Gable Junctions cannot be used when a Gable is in 'Projection' orientation.
                        <br />
                        <br />
                        You may change then to 'Parallel' and try again.
                    </>,
                ],
            };
        }
    }

    if (
        next_area_data &&
        (new_area_data.SHAPE.AREAJOIN.JoinType === "Hip" || new_area_data.SHAPE.AREAJOIN.JoinType === "Gable")
    ) {
        if (new_area_data.SHAPE.DesignSubType === "Projection" || next_area_data.SHAPE.DesignSubType === "Projection") {
            return {
                error: true,
                title: "Portal Hip/Gable Junction",
                message: [
                    <>
                        Portal Hip/Gable Junctions cannot be used when a Gable is in 'Projection' orientation.
                        <br />
                        <br />
                        You may change then to 'Parallel' and try again.
                    </>,
                ],
            };
        }
    }

    if (next_area_data && new_area_data.SHAPE.AREAJOIN.JoinType === "Hip") {
        if (new_area_data.SHAPE.Height !== next_area_data.SHAPE.Height) {
            return {
                error: true,
                title: "Portal Hip Junction",
                message: [
                    <>
                        Portal Hip Junction must have matching Height, Width and Roof Pitch in both areas.
                        <br />
                        <br />
                        Try 'Gable Junction' if Height, Width or Roof Pitch must be different
                    </>,
                ],
            };
        }
    }

    if (last_area_data && last_area_data.SHAPE.AREAJOIN.JoinType === "Hip") {
        if (last_area_data.SHAPE.Height !== new_area_data.SHAPE.Height) {
            return {
                error: true,
                title: "Portal Hip Junction",
                message: [
                    <>
                        Portal Hip Junction must have matching Height, Width and Roof Pitch in both areas.
                        <br />
                        <br />
                        Try 'Gable Junction' if Height, Width or Roof Pitch must be different
                    </>,
                ],
            };
        }
    }

    if (
        last_area_data &&
        last_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED &&
        new_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED
    ) {
        return {
            error: true,
            title: "Pitched Design",
            message: [
                <>
                    Cannot have two 'Pitched' structures adjacent to each other. Pitched structures must have a 'Flat'
                    design adjacent to it.
                </>,
            ],
        };
    }

    if (
        next_area_data &&
        next_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED &&
        new_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED
    ) {
        return {
            error: true,
            title: "Pitched Design",
            message: [
                <>
                    Cannot have two 'Pitched' structures adjacent to each other. Pitched structures must have a 'Flat'
                    design adjacent to it.
                </>,
            ],
        };
    }

    // mass settings based on NEW variable parameter
    if (parameter === "JoinType") {
        if (CONFIG.JOIN_TYPES[value]) {
            const join_data = CONFIG.JOIN_TYPES[value];
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinOffset = join_data.default_offset;

            if (value === "Angle") {
                if (new_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinAngle === 0) {
                    new_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinAngle = join_data.default_angle;
                }
            } else if (value === "Offset") {
                if (
                    new_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinAngle === 0 ||
                    new_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinAngle === 90
                ) {
                    new_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinAngle = join_data.default_angle;
                }
            } else {
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinAngle = join_data.default_angle;
            }
        }
    }

    if (parameter === "DesignType") {
        new_area_data[BASIC_SPECS_SECTIONS.SHAPE][parameter] = value;
        let design_option = config?.design_options?.[new_area_data[BASIC_SPECS_SECTIONS.SHAPE]?.DesignType];

        new_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofGroupType = design_option.roofsheet_default.grouptype;
        new_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofSubType = design_option.roofsheet_default.subtype;
        new_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING] = JOBSTATE_VALIDATION.validateRoofSheetData(
            config,
            new_job,
            areaIndex
        );

        if (design_option?.pitch_range?.default) {
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofPitch = toNumber(
                COMMON.replaceVariables(new_area_data, design_option?.pitch_range)?.default
            );
        }

        if (new_area_data[BASIC_SPECS_SECTIONS.SHAPE]?.DesignType === "Gable Hip Roof") {
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE].DesignSubType = "Parallel";
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE].RotateArea = 0;

            let new_area_GUTTERS_AND_DOWNPIPES = new_area_data[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES];
            new_area_GUTTERS_AND_DOWNPIPES.GutterB = 1;
            new_area_GUTTERS_AND_DOWNPIPES.GutterF = 1;
            new_area_GUTTERS_AND_DOWNPIPES.GutterL = 0;
            new_area_GUTTERS_AND_DOWNPIPES.GutterR = 0;

            if (old_area_data[BASIC_SPECS_SECTIONS.SHAPE]?.DesignType !== "Gable Hip Roof") {
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Back = 0;
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Front = 0;
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Left = 0;
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Right = 0;
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Back_Sheet = 0;
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Front_Sheet = 0;
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Left_Sheet = 0;
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Right_Sheet = 0;
            }
        } else if (new_area_data[BASIC_SPECS_SECTIONS.SHAPE]?.DesignType === "Flat Roof") {
            let new_area_GUTTERS_AND_DOWNPIPES = new_area_data[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES];
            let new_area_ATTACHMENTS = new_area_data[BASIC_SPECS_SECTIONS.ATTACHMENTS];
            new_area_GUTTERS_AND_DOWNPIPES.GutterB = 0;
            new_area_GUTTERS_AND_DOWNPIPES.GutterF = 1 - new_area_ATTACHMENTS.AttachmentBottom;

            if (old_area_data[BASIC_SPECS_SECTIONS.SHAPE]?.DesignType !== "Flat Roof") {
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Back = 0;
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Front = 0;
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Left = 0;
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Right = 0;
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Back_Sheet = 0;
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Front_Sheet = 0;
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Left_Sheet = 0;
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Right_Sheet = 0;
            }
        }

        let new_area_BEAMS_AND_POSTS = new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS];
        if (design_option) {
            if (design_option?.beam_1) new_area_BEAMS_AND_POSTS.BeamType1 = design_option.beam_1.section_default;
            if (design_option?.beam_2) new_area_BEAMS_AND_POSTS.BeamType2 = design_option.beam_2.section_default;
            if (design_option?.beam_3) new_area_BEAMS_AND_POSTS.BeamType3 = design_option.beam_3.section_default;
            if (design_option?.beam_4) new_area_BEAMS_AND_POSTS.BeamType4 = design_option.beam_4.section_default;
            if (design_option?.post) new_area_BEAMS_AND_POSTS.PostType = design_option.post.section_default;
        }
    }

    if (parameter === "DesignSubType") {
        if (new_area_data[BASIC_SPECS_SECTIONS.SHAPE].DesignType === "Gable Hip Roof") {
            if (new_area_data[BASIC_SPECS_SECTIONS.SHAPE].DesignSubType === "Projection") {
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE].RotateArea = 1;
                let new_area_ATTACHMENTS = { ...new_area_data[BASIC_SPECS_SECTIONS.ATTACHMENTS] };
                new_area_ATTACHMENTS.AttachmentLeft = new_area_data[BASIC_SPECS_SECTIONS.ATTACHMENTS].AttachmentTop;
                new_area_ATTACHMENTS.AttachmentTop = new_area_data[BASIC_SPECS_SECTIONS.ATTACHMENTS].AttachmentRight;
                new_area_ATTACHMENTS.AttachmentRight = new_area_data[BASIC_SPECS_SECTIONS.ATTACHMENTS].AttachmentBottom;
                new_area_ATTACHMENTS.AttachmentBottom = new_area_data[BASIC_SPECS_SECTIONS.ATTACHMENTS].AttachmentLeft;

                //adjust paats
                for (let PAAT of new_area_ATTACHMENTS.PARTIAL_ATTACHMENTS) {
                    if (PAAT.Ref.includes("Back")) PAAT.Ref = PAAT.Ref.replace("Back", "Right");
                    else if (PAAT.Ref.includes("Front")) PAAT.Ref = PAAT.Ref.replace("Front", "Left");
                    else if (PAAT.Ref.includes("Left")) PAAT.Ref = PAAT.Ref.replace("Left", "Back");
                    else if (PAAT.Ref.includes("Right")) PAAT.Ref = PAAT.Ref.replace("Right", "Front");
                    PAAT.Name = PAAT.Ref;
                }

                //adjust mods
                for (let mods of new_area_ATTACHMENTS.AttachmentModifications) {
                    if (mods.Ref.includes("Back")) mods.Ref = mods.Ref.replace("Back", "Right");
                    else if (mods.Ref.includes("Front")) mods.Ref = mods.Ref.replace("Front", "Left");
                    else if (mods.Ref.includes("Left")) mods.Ref = mods.Ref.replace("Left", "Back");
                    else if (mods.Ref.includes("Right")) mods.Ref = mods.Ref.replace("Right", "Front");
                    mods.Name = mods.Ref;
                }

                new_area_data[BASIC_SPECS_SECTIONS.ATTACHMENTS] = new_area_ATTACHMENTS;

                let new_area_GUTTERS_AND_DOWNPIPES = new_area_data[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES];
                new_area_GUTTERS_AND_DOWNPIPES.GutterB = 1 - new_area_ATTACHMENTS.AttachmentTop;
                new_area_GUTTERS_AND_DOWNPIPES.GutterF = 1 - new_area_ATTACHMENTS.AttachmentBottom;
                new_area_GUTTERS_AND_DOWNPIPES.GutterL = 0;
                new_area_GUTTERS_AND_DOWNPIPES.GutterR = 0;
            } else {
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE].RotateArea = 0;
                let new_area_ATTACHMENTS = { ...new_area_data[BASIC_SPECS_SECTIONS.ATTACHMENTS] };
                new_area_ATTACHMENTS.AttachmentLeft = new_area_data[BASIC_SPECS_SECTIONS.ATTACHMENTS].AttachmentBottom;
                new_area_ATTACHMENTS.AttachmentRight = new_area_data[BASIC_SPECS_SECTIONS.ATTACHMENTS].AttachmentTop;
                new_area_ATTACHMENTS.AttachmentTop = new_area_data[BASIC_SPECS_SECTIONS.ATTACHMENTS].AttachmentLeft;
                new_area_ATTACHMENTS.AttachmentBottom = new_area_data[BASIC_SPECS_SECTIONS.ATTACHMENTS].AttachmentRight;

                //adjust paats
                for (let PAAT of new_area_ATTACHMENTS.PARTIAL_ATTACHMENTS) {
                    if (PAAT.Ref.includes("Back")) PAAT.Ref = PAAT.Ref.replace("Back", "Left");
                    else if (PAAT.Ref.includes("Front")) PAAT.Ref = PAAT.Ref.replace("Front", "Right");
                    else if (PAAT.Ref.includes("Left")) PAAT.Ref = PAAT.Ref.replace("Left", "Front");
                    else if (PAAT.Ref.includes("Right")) PAAT.Ref = PAAT.Ref.replace("Right", "Back");
                    PAAT.Name = PAAT.Ref;
                }

                //adjust mods
                for (let mods of new_area_ATTACHMENTS.AttachmentModifications) {
                    if (mods.Ref.includes("Back")) mods.Ref = mods.Ref.replace("Back", "Left");
                    else if (mods.Ref.includes("Front")) mods.Ref = mods.Ref.replace("Front", "Right");
                    else if (mods.Ref.includes("Left")) mods.Ref = mods.Ref.replace("Left", "Front");
                    else if (mods.Ref.includes("Right")) mods.Ref = mods.Ref.replace("Right", "Back");
                    mods.Name = mods.Ref;
                }

                new_area_data[BASIC_SPECS_SECTIONS.ATTACHMENTS] = new_area_ATTACHMENTS;

                let new_area_GUTTERS_AND_DOWNPIPES = new_area_data[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES];
                new_area_GUTTERS_AND_DOWNPIPES.GutterB = 1 - new_area_ATTACHMENTS.AttachmentTop;
                new_area_GUTTERS_AND_DOWNPIPES.GutterF = 1 - new_area_ATTACHMENTS.AttachmentBottom;
                new_area_GUTTERS_AND_DOWNPIPES.GutterL = 0;
                new_area_GUTTERS_AND_DOWNPIPES.GutterR = 0;
            }
        } else {
            let val_split = value.split("/");
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE].DesignSubType = val_split[0];
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE].SheetDirection = val_split[1];
        }
    }

    if (parameter === "RoofType1") {
        if (value === "Hip/45") {
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE]["RoofType1"] = "Hip";
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE]["HipAngle1"] = 45;
        } else if (value === "Hip/60") {
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE]["RoofType1"] = "Hip";
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE]["HipAngle1"] = 60;
        }

        if (
            old_area_data[BASIC_SPECS_SECTIONS.SHAPE]["RoofType1"] !==
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE]["RoofType1"]
        ) {
            if (new_area_data[BASIC_SPECS_SECTIONS.SHAPE]["RoofType1"] !== "Gable")
                new_area_data[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES].GutterL = 1;
            else new_area_data[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES].GutterL = 0;
        }
    }

    if (parameter === "RoofType2") {
        if (value === "Hip/45") {
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE]["RoofType2"] = "Hip";
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE]["HipAngle2"] = 45;
        } else if (value === "Hip/60") {
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE]["RoofType2"] = "Hip";
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE]["HipAngle2"] = 60;
        }

        if (
            old_area_data[BASIC_SPECS_SECTIONS.SHAPE]["RoofType2"] !==
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE]["RoofType2"]
        ) {
            if (new_area_data[BASIC_SPECS_SECTIONS.SHAPE]["RoofType2"] !== "Gable")
                new_area_data[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES].GutterR = 1;
            else new_area_data[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES].GutterR = 0;
        }
    }

    let errors = [];

    if (window.LYSAGHT) {
        if (
            new_area_data.SHAPE.RoofPitch === 15 &&
            (new_area_data[BASIC_SPECS_SECTIONS.SHAPE]["RoofType1"] !== "Gable" ||
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE]["RoofType2"] !== "Gable")
        ) {
            errors.push({
                error: true,
                title: "Gable ends must be Gable for 15 degree roof pitch.",
                message: [<>Gable ends must be Gable for 15 degree roof pitch. Ends have been reset to Gable.</>],
            });
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE]["RoofType1"] = "Gable";
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE]["RoofType2"] = "Gable";
        }
    }

    // forced compliance/ mass settings, updates
    new_job = JOBSTATE_VALIDATION.validateFullJob(config, new_job, -1, getState().app);

    dispatch({
        type: NEW_JOB,
        parameter: new_job,
    });

    // warnings
    if (parameter === "JoinType" && value === "Hip") {
        return {
            error: true,
            title: "Hip Portal Design",
            message: [
                window?.FIELDERS ? (
                    <>
                        In a Portal Gable Hip Design, The Width and Roof Pitch of the two areas will be automatically
                        matched. Purlins must be inset 65 beams.
                    </>
                ) : (
                    <>
                        In a Portal Gable Hip Design, The Width and Roof Pitch of the two areas will be automatically
                        matched.
                    </>
                ),
            ],
        };
    }

    let error = JOBSTATE_VALIDATION.CheckSuggestions(config, new_job, areaIndex, getState().app)(dispatch);
    if (error) return error;
    if (errors && errors.length > 0) return ConsolidateErrors(errors);
};

export const updateAreaSpecificationRoofSheet = (areaIndex, subsection, parameter, value) => (dispatch, getState) => {
    if (isLocked(getState().app, getState().job)) return;

    let new_job = COMMON.deepCopy(getState().job);
    let new_area_data = new_job.AreaSpecifications[areaIndex];

    const config = getState().config;

    if (value?.target?.value) value = value?.target?.value;

    // Set default roof span to trafficable if none set
    if (
        !new_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING]["RoofSpan"] ||
        new_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING]["RoofSpan"] === ""
    )
        new_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING]["RoofSpan"] = "No Foot Traffic";

    if (parameter === "RoofGroupType") {
        let roofsheet_types = config.roofsheet_types;
        let roofsheetgroup_old = roofsheet_types[new_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofGroupType];
        let roofsheetgroup = roofsheet_types[value];

        if (roofsheetgroup.min_pitch && new_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT) {
            if (new_area_data[BASIC_SPECS_SECTIONS.SHAPE]["RoofPitch"] !== toNumber(roofsheetgroup.min_pitch)) {
                dispatch({
                    type: SHOW_DESIGNER_MESSAGE,
                    message: {
                        message:
                            "Roof pitch has been changed from " +
                            new_area_data[BASIC_SPECS_SECTIONS.SHAPE]["RoofPitch"] +
                            "° to " +
                            toNumber(roofsheetgroup.min_pitch) +
                            "° (the minimum pitch for " +
                            value +
                            ")",
                        type: "success",
                    },
                });
                new_area_data[BASIC_SPECS_SECTIONS.SHAPE]["RoofPitch"] = toNumber(roofsheetgroup.min_pitch);
            }
        }

        if (
            roofsheetgroup_old?.min_front_overhang &&
            toNumber(new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Front) ===
                toNumber(roofsheetgroup_old?.min_front_overhang)
        ) {
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Front = roofsheetgroup?.min_front_overhang
                ? toNumber(roofsheetgroup?.min_front_overhang)
                : 0;
        }

        if (
            roofsheetgroup_old?.min_front_overhang &&
            toNumber(new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Back) ===
                toNumber(roofsheetgroup_old?.min_front_overhang)
        ) {
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Back = roofsheetgroup?.min_front_overhang
                ? toNumber(roofsheetgroup?.min_front_overhang)
                : 0;
        }

        if (
            roofsheetgroup_old?.min_side_overhang &&
            toNumber(new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Left) ===
                toNumber(roofsheetgroup_old?.min_side_overhang)
        ) {
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Left = roofsheetgroup?.min_side_overhang
                ? toNumber(roofsheetgroup?.min_side_overhang)
                : 0;
        }

        if (
            roofsheetgroup_old?.min_side_overhang &&
            toNumber(new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Right) ===
                toNumber(roofsheetgroup_old?.min_side_overhang)
        ) {
            new_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Right = roofsheetgroup?.min_side_overhang
                ? toNumber(roofsheetgroup?.min_side_overhang)
                : 0;
        }

        if (value === "CUSTOM ORB") {
            let design_option = config?.design_options?.[new_area_data.SHAPE.DesignType];
            if (design_option?.allow_roll_top_ridge) {
                new_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RollTopRidge = true;
            }
        }
    }

    if (!subsection && !parameter) new_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING] = value;
    else if (subsection) new_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING][subsection][parameter] = value;
    else new_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING][parameter] = value;

    if (
        (parameter === "SheetLaying" || parameter === "SheetLayingOffset") &&
        new_area_data &&
        new_area_data.SKYLIGHTS.length > 0
    ) {
        return {
            error: true,
            title: "Skylights will be wiped",
            message: [<>If you change the laying point, skylights will be wiped.</>],
            primaryActionText: "Change laying point",
            primaryAction: () => {
                new_area_data.SKYLIGHTS = [];
                //forced compliance/ mass settings, updates
                new_job = JOBSTATE_VALIDATION.validateFullJob(config, new_job, -1, getState().app);

                dispatch({
                    type: NEW_JOB,
                    parameter: new_job,
                });
            },
            secondaryActionText: "Cancel",
            secondaryAction: null,
        };
    }

    //forced compliance/ mass settings, updates
    new_job = JOBSTATE_VALIDATION.validateFullJob(config, new_job, -1, getState().app);

    dispatch({
        type: NEW_JOB,
        index: areaIndex,
        section: null,
        subsection: null,
        parameter: new_job,
        value: null,
        error: null,
    });

    let errors = jobStateErrorPopups({ config, job: new_job, app: getState()?.app, dispatch });
    if (errors) {
        return errors;
    }
};

export const updateAreaSpecificationBeamPost = (areaIndex, subsection, parameter, value) => (dispatch, getState) => {
    if (isLocked(getState().app, getState().job)) return;

    let new_job = COMMON.deepCopy(getState().job);
    let new_area_data = new_job.AreaSpecifications[areaIndex];
    const config = getState().config;
    const designType = new_area_data.SHAPE?.DesignType;
    const maxLengthRHS = 8000;

    let errors = [];
    let oldBeamSelection = "";

    if (value?.target?.value) value = value?.target?.value;

    if (!subsection && !parameter) {
        new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS] = value;
    } else if (subsection) {
        new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS][subsection][parameter] = value;
    } else {
        oldBeamSelection = new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS][parameter];
        new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS][parameter] = value;
    }

    // Check for RHS inserts longer than max
    if (!window.LYSAGHT) {
        const resultSet = JOBSTATE_VALIDATION.validateRHSBeamLength(config, new_job, areaIndex, value);
        const match = resultSet.has(parameter);

        if (match) {
            let beamName = undefined;

            switch (parameter) {
                case "BeamType1":
                    beamName = config?.design_options?.[designType].beam_1.Name;
                    break;
                case "BeamType2":
                    beamName = config?.design_options?.[designType].beam_2.Name;
                    break;
                case "BeamType3":
                    beamName = config?.design_options?.[designType].beam_3.Name;
                    break;
                case "BeamType4":
                    beamName = config?.design_options?.[designType].beam_4.Name;
                    break;
            }

            if (beamName) {
                errors.push({
                    error: true,
                    title: `${beamName} length exceeds RHS insert availability`,
                    message: [
                        <>
                            At least one {beamName} in this design exceeds the {maxLengthRHS}mm limit for RHS inserts.
                            <br />
                            Beams under the RHS limit can be modified individually.
                        </>,
                    ],
                });

                // Beam isn't changing so restore original selection
                new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS][parameter] = oldBeamSelection;
            }
        }
    }

    let had_notched_posts = false;

    if (new_job.DesignParameters.DeckMode) {
        let is_larger = false;
        //cannot have joist smaller than bearer
        if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType1 === "SB15865") {
            if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2 === "SB20865") {
                is_larger = true;
            }
        }
        if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType1 === "SB10865") {
            if (
                new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2 === "SB20865" ||
                new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2 === "SB15865"
            ) {
                is_larger = true;
            }
        }
        if (is_larger) {
            errors.push({
                error: true,
                title: "Joist larger than Bearer",
                message: [<>Joist cannot be a larger section than Bearer. Joist has been adjusted to match.</>],
            });
        }
    } else {
        let is_portal = false;
        if (new_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) is_portal = true;

        if (
            new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].CornerPostsFullHeight === 2 ||
            new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].IntermediatePostsFullHeight === 2
        ) {
            had_notched_posts = true;
            if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostColMatchBeam === "Merbau") {
                if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].CornerPostsFullHeight === 2)
                    new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].CornerPostsFullHeight = 3;
                if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].IntermediatePostsFullHeight === 2)
                    new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].IntermediatePostsFullHeight = 3;
                errors.push({
                    error: true,
                    title: "Merbau is not available in Notched.",
                    message: [
                        <>Merbau is not available in Notched. Post Postion has been set to "Post Behind Beam".</>,
                    ],
                });
            }
        }

        if (!is_portal) {
            if (
                new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType3.includes("FL20020") &&
                new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2.includes("FL10011")
            ) {
                errors.push({
                    error: true,
                    title: "FL100 Purlins cannot be used with FL200 Rafter",
                    message: [<>FL100 Purlins cannot be used with FL200 Rafters. Purlins have been set to FL150.</>],
                });
                new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2 = "FL15015";
            }

            if (
                new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType3.includes("FL10011") &&
                new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2.includes("FL15015")
            ) {
                errors.push({
                    error: true,
                    title: "FL150 Purlins cannot be used with FL100 Rafter",
                    message: [<>FL150 Purlins cannot be used with FL100 Rafters. Purlins have been set to FL100.</>],
                });
                new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2 = "FL10011";
            }
        }

        if (is_portal) {
            if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType1.includes("FL10011")) {
                if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].CollarTie === 0) {
                    errors.push({
                        error: true,
                        title: "Gables with FL100 Rafters must have Collar Ties",
                        message: [<>Gables with FL100 Rafters must have Collar Ties. Collar Ties have been enabled.</>],
                    });
                    new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].CollarTie = 1;
                    new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].CollarTieBeam = "FL10011";
                }
                if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].DoubleIntermediateRafters === 1) {
                    errors.push({
                        error: true,
                        title: "Gables with FL100 Rafters cannot be doubled",
                        message: [<>Gables with FL100 Rafters cannot be doubled. Rafters have been set to single.</>],
                    });
                    new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].DoubleIntermediateRafters = 0;
                }
                if (
                    new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2.includes("FL15015") ||
                    new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2.includes("FL20020")
                ) {
                    errors.push({
                        error: true,
                        title: "FL100 Rafters cannot have larger purlins",
                        message: [<>FL100 Rafters cannot have larger purlins. Purlins have been set to FL100.</>],
                    });
                    new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2 = "FL10011";
                }
                if (
                    new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType4.includes("FL15015") ||
                    new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType4.includes("FL20020")
                ) {
                    errors.push({
                        error: true,
                        title: "Hip Beam cannot be larger than rafter",
                        message: [<>Hip Beams can not be larger than the Rafter. Hip beam set to FL100.</>],
                    });
                    new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType4 = "FL10011";
                }
            } else if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType1.includes("FL15015")) {
                if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2.includes("FL15015")) {
                    if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType4.includes("FL10011")) {
                        if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].CollarTie === 1) {
                            errors.push({
                                error: true,
                                title: "FL100 Hip Beam cannot have FL150 Purlins",
                                message: [
                                    <>
                                        FL100 Hip Beam cannot have FL150 Purlins. Hip has been set to FL150. (Caused by
                                        Collar tie option)
                                    </>,
                                ],
                            });
                            new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType4 = "FL15015";
                        } else
                            errors.push({
                                error: true,
                                title: "FL100 Hip Beam cannot have FL150 Purlins",
                                message: [<>FL100 Hip Beam cannot have FL150 Purlins. Purlin has been set to FL100.</>],
                            });
                        new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2 = "FL10011";
                    }
                }
                if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2.includes("FL20020")) {
                    errors.push({
                        error: true,
                        title: "FL150 Rafters cannot have larger purlins",
                        message: [<>FL150 Rafters cannot have larger purlins. Purlins have been set to FL150.</>],
                    });
                    new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2 = "FL15015";
                    // Check Hip
                    if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType4.includes("FL10011")) {
                        errors.push({
                            error: true,
                            title: "FL100 Hip Beam cannot have FL150 purlins",
                            message: [<>FL100 Hip Beam cannot have FL150 purlins. Hip Beam has been set to FL150.</>],
                        });
                        new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType4 = "FL15015";
                    }
                }
            } else if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType1.includes("FL20020")) {
                if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].CollarTie === 1) {
                    errors.push({
                        error: true,
                        title: "Gables with FL200 Rafters cannot have Collar Ties",
                        message: [
                            <>Gables with FL200 Rafters cannot have Collar Ties. Collar Ties have been removed.</>,
                        ],
                    });
                    new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].CollarTie = 0;
                }
                if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2.includes("FL10011")) {
                    errors.push({
                        error: true,
                        title: "FL200 Rafters cannot have FL100 purlins",
                        message: [<>FL200 Rafters cannot have FL100 purlins. Purlins have been set to FL150.</>],
                    });
                    new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2 = "FL15015";
                    if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType4.includes("FL10011")) {
                        errors.push({
                            error: true,
                            title: "FL150 Purlin cannot have FL100 Hip Beam",
                            message: [<>FL150 Purlin cannot have FL100 Hip Beam. Hip beam has been set to FL150.</>],
                        });
                        new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType4 = "FL15015";
                    }
                }
                if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType3.includes("FL15015")) {
                    errors.push({
                        error: true,
                        title: "FL200 Rafters cannot have FL150 Edge Beam",
                        message: [<>FL200 Rafters cannot have FL150 Edge Beam. Edge Beam has been set to FL200.</>],
                    });
                    new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType3 = "FL20020";
                }
            }
            if (window.LYSAGHT) {
                if (
                    new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].CollarTie === 1 &&
                    new_area_data[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS]["DownlightFlashing"] === 1
                ) {
                    errors.push({
                        error: true,
                        title: "Gable with Collar Ties cannot have Downlight Tray",
                        message: [
                            <>Gable with Collar Ties cannot have Downlight Tray. Downlight Tray has been removed.</>,
                        ],
                    });
                    new_area_data[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS]["DownlightFlashing"] = 0;
                }
            }
        }
    }

    // Forced compliance/mass settings, updates
    new_job = JOBSTATE_VALIDATION.validateFullJob(config, new_job, -1, getState().app);

    let merbau_error = false;

    if (had_notched_posts) {
        if (
            new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].CornerPostsFullHeight !== 2 &&
            new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].IntermediatePostsFullHeight !== 2 &&
            new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostColMatchBeam === "Merbau"
        ) {
            merbau_error = {
                error: true,
                title: "Merbau is not available in Notched.",
                message: [<>Merbau is not available in Notched. Post Postion has been set to "Post Behind Beam".</>],
            };
        }
    }

    if (
        new_area_data.Footings?.length > 0 &&
        new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.PostCol === "Merbau"
    ) {
        // Change back footing types to concrete in (No Flanged)
        // If error message already there add both cases
        if (merbau_error) {
            merbau_error = {
                error: true,
                title: "Merbau is not available in Notched or Flanged.",
                message: [
                    <>
                        Merbau is not available in Notched or Flanged, Post Footing has been set to "Concrete In". Post
                        Postion has been set to "Post Behind Beam". Select another post colour to change Footing Type or
                        Post Position.
                    </>,
                ],
            };
        } else {
            merbau_error = {
                error: true,
                title: "Merbau is not available in Flanged.",
                message: [
                    <>
                        Merbau is not available in Flanged, Post Footing has been set to "Concrete In". Select another
                        post colour to change footing type.
                    </>,
                ],
            };
        }

        new_area_data.Footings.forEach((item, i) =>
            deleteFromAreaSpecificationModificationArray(areaIndex, "Footings", item.Ref)
        );
        new_area_data.Footings = [];
    }
    if (merbau_error) errors.push(merbau_error);

    dispatch({
        type: NEW_JOB,
        index: areaIndex,
        section: null,
        subsection: null,
        parameter: new_job,
        value: null,
        error: null,
    });

    if (errors && errors.length > 0) return ConsolidateErrors(errors);
};

const ConsolidateErrors = (errors) => {
    if (!errors) return false;
    if (errors.length === 1) return errors[0];

    let consolidated_message = [];

    for (let error of errors) {
        consolidated_message.push(<li>{error.message[0]}</li>);
    }
    return {
        error: true,
        title: "Multiple Errors/Updates",
        message: [
            <ul
                style={{
                    padding: "0px 16px",
                }}
            >
                {consolidated_message}
            </ul>,
        ],
    };
};

export const updateAreaSpecificationGutterDownpipe =
    (areaIndex, subsection, parameter, value) => (dispatch, getState) => {
        if (isLocked(getState().app, getState().job)) return;

        let new_job = COMMON.deepCopy(getState().job);
        let user = COMMON.deepCopy(getState().app.user);
        let new_area_data = new_job.AreaSpecifications[areaIndex];
        const config = getState().config;

        if (value?.target?.value) value = value?.target?.value;

        //
        if (!subsection && !parameter) new_area_data[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES] = value;
        else if (subsection) new_area_data[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES][subsection][parameter] = value;
        else new_area_data[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES][parameter] = value;

        //forced compliance/ mass settings, updates
        new_job = JOBSTATE_VALIDATION.validateFullJob(config, new_job, -1, getState().app);

        dispatch({
            type: NEW_JOB,
            index: areaIndex,
            section: null,
            subsection: null,
            parameter: new_job,
            value: null,
            error: null,
        });

        let error = JOBSTATE_VALIDATION.CheckSuggestions(config, new_job, areaIndex, getState().app)(dispatch);
        let warnings = JOBSTATE_VALIDATION.getWarnings(new_job, user, config);

        if (error) return error;
    };

export const updateAreaSpecificationValidateJob = (areaIndex, section, parameter, value) => (dispatch, getState) => {
    let subsection = null;
    if (parameter && parameter.includes(".")) {
        let parameter_split = parameter.split(".");
        subsection = parameter_split[0];
        parameter = parameter_split[1];
    } else if (section && section.includes(".")) {
        let section_split = section.split(".");
        section = section_split[0];
        subsection = section_split[1];
    }

    let new_job = COMMON.deepCopy(getState().job);
    let new_area_data = new_job.AreaSpecifications[areaIndex];
    const config = getState().config;

    if (value?.target?.value) value = value?.target?.value;

    if (!subsection && !parameter) new_area_data[section] = value;
    else if (subsection) new_area_data[section][subsection][parameter] = value;
    else new_area_data[section][parameter] = value;

    //forced compliance/ mass settings, updates
    new_job = JOBSTATE_VALIDATION.validateFullJob(config, new_job, -1, getState().app);

    dispatch({
        type: NEW_JOB,
        index: areaIndex,
        section: null,
        subsection: null,
        parameter: new_job,
        value: null,
        error: null,
    });

    let error = JOBSTATE_VALIDATION.CheckSuggestions(config, new_job, areaIndex, getState().app)(dispatch);
    if (error) return error;
};

export const updateAreaSpecificationGableParameters =
    (areaIndex, subsection, parameter, value) => (dispatch, getState) => {
        if (isLocked(getState().app, getState().job)) return;

        let new_job = COMMON.deepCopy(getState().job);
        let new_area_data = new_job.AreaSpecifications[areaIndex];
        const config = getState().config;

        if (value?.target?.value) value = value?.target?.value;
        if (!subsection && !parameter) new_area_data[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS] = value;
        else if (subsection) new_area_data[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS][subsection][parameter] = value;
        else new_area_data[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS][parameter] = value;

        let error;
        if (new_area_data[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS].InfillBeamType === "656510") {
            if (
                new_area_data[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES].GutterL > 0 ||
                new_area_data[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES].GutterR > 0
            ) {
                return {
                    error: true,
                    title: "Gable End with Gutter",
                    message: [<>Gable End Infill Beam cannot be 656510 when it is supporting a gutter.</>],
                };
            }
            if (new_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth >= 4500) {
                return {
                    error: true,
                    title: "Gable Width Beam Limit",
                    message: [<>Gable End Infill Beam cannot be 656510 when Gable Width over 4500mm.</>],
                };
            }
        }

        if (parameter === "DownlightFlashing") {
            if (window.LYSAGHT) {
                if (new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].CollarTie === 1) {
                    error = {
                        error: true,
                        title: "Gable with Collar Ties cannot have Downlight Tray",
                        message: [<>Gable with Collar Ties cannot have Downlight Tray.</>],
                    };
                    new_area_data[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS].DownlightFlashing = 0;
                }
            }
        }

        if (window.LYSAGHT && parameter === "InfillBeamType") {
            if (
                new_area_data[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS].InfillBeamType !==
                new_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType3
            ) {
                error = {
                    error: true,
                    title: "Infill Beam is matched with Edge Beam.",
                    message: [<>Infill Beam is matched with Edge Beam.</>],
                };
            }
        }

        new_job.AreaSpecifications[areaIndex] = new_area_data;
        new_area_data.GABLE_PARAMETERS = JOBSTATE_VALIDATION.validateGableParameters(config, new_job, areaIndex);
        new_job = JOBSTATE_VALIDATION.validateFullJob(config, new_job, -1, getState().app);

        dispatch({
            type: NEW_JOB,
            index: areaIndex,
            section: null,
            subsection: null,
            parameter: new_job,
            value: null,
            error: null,
        });

        if (error) return error;
    };

export const updateAreaSpecification =
    (areaIndex, section, parameter, value, validate = false) =>
    (dispatch, getState) => {
        let subsection = null;
        let error = null;
        let schema = null;
        let job = COMMON.deepCopy(getState().job);

        const config = getState().config;
        const validationSchema = config?.validationSchema;

        if (parameter && parameter.includes(".")) {
            let parameter_split = parameter.split(".");
            subsection = parameter_split[0];
            parameter = parameter_split[1];
        } else if (section && section.includes(".")) {
            let section_split = section.split(".");
            section = section_split[0];
            subsection = section_split[1];
        }

        if (validationSchema) {
            schema = get(
                validationSchema,
                "AreaSpecifications." +
                    areaIndex +
                    "." +
                    section +
                    (subsection ? "." + subsection : "") +
                    "." +
                    parameter
            );

            if (schema) {
                error = JOBSTATE_VALIDATION.checkValidationScheme(schema, value);
            }
        }

        if (section === BASIC_SPECS_SECTIONS.SHAPE) {
            validateMinNumberOfIntBeams(config, areaIndex, section, subsection, parameter, value, job, dispatch);
        }

        if (section === "Footings") {
            value = dispatch(JOBSTATE_VALIDATION.validateFootingModifications(job, areaIndex, value));
        }

        return new Promise((resolve) => {
            dispatch({
                type: UPDATE_AREA_SPECIFICATION,
                index: areaIndex,
                section: section,
                subsection: subsection,
                parameter: parameter,
                value: value,
                error: error,
                config: config,
            });
            resolve("OK");
        });
    };

export const updateAreaSpecificationOnly = (areaIndex, section, parameter, value) => (dispatch) => {
    let subsection = null;
    if (parameter && parameter.includes(".")) {
        let parameter_split = parameter.split(".");
        subsection = parameter_split[0];
        parameter = parameter_split[1];
    }

    dispatch({
        type: UPDATE_AREA_SPECIFICATION,
        index: areaIndex,
        section: section,
        subsection: subsection,
        parameter: parameter,
        value: value,
    });
    return Promise.resolve();
};

export const newJob =
    (user_data, in_job_data = null, design_selected = null, subTypeSelected = null) =>
    (dispatch, getState) => {
        return new Promise((resolve) => {
            let api_url =
                API_BASE() +
                "admin/getnextvalidjobid/?bus=" +
                (in_job_data?.Distributor?.id ? in_job_data?.Distributor?.id : user_data.BusinessCode);

            fetchTimeout(api_url, {
                method: "GET",
            })
                .then(async (response) => {
                    if (response && response?.status && response.status >= 200 && response.status <= 300) {
                        let id = await response.text();
                        let new_qn = id;
                        let config = getState().config;
                        let new_job_data = COMMON.deepCopy(newDefaultJobState(config, new_qn, user_data));

                        if (in_job_data) {
                            new_job_data.preprod = in_job_data.preprod;
                            new_job_data.Customer = { ...in_job_data.Customer };
                            new_job_data.BusinessCode = in_job_data.BusinessCode;
                            new_job_data.Distributor = { ...in_job_data.Distributor };
                            new_job_data.SiteParameters = { ...in_job_data.SiteParameters };
                            new_job_data.DesignParameters = { ...in_job_data.DesignParameters };
                            new_job_data.Notes = [...in_job_data.Notes];
                            new_job_data.OrderDate = 0;
                            new_job_data.CreationDate = Date.now();
                            new_job_data.DesignParameters.USE_ATTACHMENTS_2 = true;
                            new_job_data.DesignParameters.UseAreaJoinExtensions = false;
                            new_job_data.History = [];
                            new_job_data.History.push({ Created: new Date(Date.now()).toUTCString() });

                            if (design_selected.includes("Deck")) {
                                new_job_data.DesignParameters.DeckMode = 1;
                                new_job_data.SiteParameters.ExistingStructure.AttachmentType = "Wall";
                                if (config?.design_options?.["Flat Deck"]?.default_area_template) {
                                    let template = config?.design_options?.["Flat Deck"]?.default_area_template;
                                    new_job_data.AreaSpecifications[0] = _merge(
                                        new_job_data.AreaSpecifications[0],
                                        template
                                    );
                                }

                                new_job_data.AreaSpecifications[0].SHAPE.Length =
                                    in_job_data.AreaSpecifications[0].SHAPE.Length;
                                new_job_data.AreaSpecifications[0].SHAPE.Height =
                                    in_job_data.AreaSpecifications[0].SHAPE.Height;
                                new_job_data.AreaSpecifications[0].SHAPE.Depth =
                                    in_job_data.AreaSpecifications[0].SHAPE.Depth;
                                new_job_data.AreaSpecifications[0].SHAPE.CUTOUTS =
                                    in_job_data.AreaSpecifications[0].SHAPE.CUTOUTS;
                                new_job_data.AreaSpecifications[0].ATTACHMENTS =
                                    in_job_data.AreaSpecifications[0].ATTACHMENTS;

                                new_job_data.AcceptedWarnings = in_job_data.AcceptedWarnings;

                                if (new_job_data.AreaSpecifications[0]?.BEAMS_AND_POSTS?.PurlinSpacing != null)
                                    new_job_data.AreaSpecifications[0].BEAMS_AND_POSTS.PurlinSpacing =
                                        in_job_data.AreaSpecifications[0].BEAMS_AND_POSTS.PurlinSpacing;
                            } else if (design_selected === "Gable") {
                                if (config?.design_options?.["Gable Hip Roof"]?.default_area_template) {
                                    let template = config?.design_options?.["Gable Hip Roof"]?.default_area_template;
                                    new_job_data.AreaSpecifications[0] = _merge(
                                        new_job_data.AreaSpecifications[0],
                                        template
                                    );
                                }
                            } else if (design_selected === "Gable") {
                                if (config?.design_options?.["Gable Hip Roof"]?.default_area_template) {
                                    let template = config?.design_options?.["Gable Hip Roof"]?.default_area_template;
                                    new_job_data.AreaSpecifications[0] = _merge(
                                        new_job_data.AreaSpecifications[0],
                                        template
                                    );
                                }
                            } else if (design_selected === "National Carport") {
                                new_job_data.DesignParameters.CarportMode = 1;
                                if (config?.design_options?.["National Carport"]?.design_templates[subTypeSelected]) {
                                    let template =
                                        config?.design_options?.["National Carport"]?.design_templates[subTypeSelected];
                                    new_job_data.AreaSpecifications[0] = _merge(
                                        new_job_data.AreaSpecifications[0],
                                        template
                                    );
                                }
                            } else if (design_selected === "Louvreroof") {
                                if (config?.design_options?.["Louvre Roof"]?.default_area_template) {
                                    let template = config?.design_options?.["Louvre Roof"]?.default_area_template;
                                    new_job_data.AreaSpecifications[0] = _merge(
                                        new_job_data.AreaSpecifications[0],
                                        template
                                    );
                                }
                            } else {
                                if (config?.design_options?.["Flat Roof"]?.default_area_template) {
                                    let template = config?.design_options?.["Flat Roof"]?.default_area_template;
                                    new_job_data.AreaSpecifications[0] = _merge(
                                        new_job_data.AreaSpecifications[0],
                                        template
                                    );
                                }
                            }
                        }

                        dispatch({
                            type: NEW_JOB,
                            parameter: new_job_data,
                        });

                        if (new_job_data?.DesignParameters?.CustomisedOffering) {
                            dispatch(CONFIG.loadOffering(new_job_data));
                        }

                        return resolve();
                    } else {
                        let error = await response.text();
                        return resolve("ERROR: " + error);
                    }
                })
                .catch((e) => {
                    return resolve("ERROR");
                });
        });
    };

export const newDuplicateJob =
    (user_data, in_job_data = null) =>
    (dispatch) => {
        return new Promise((resolve) => {
            let api_url = API_BASE() + "admin/getnextvalidjobid/?bus=" + in_job_data.BusinessCode;

            fetchTimeout(api_url, {
                method: "GET",
            })
                .then(async (response) => {
                    if (response && response?.status && response.status >= 200 && response.status <= 300) {
                        let id = await response.text();
                        let new_qn = id;
                        let new_job_data = COMMON.deepCopy(in_job_data);

                        new_job_data.id = new_qn;
                        new_job_data.Status = "Design";
                        new_job_data.OrderStatus = "";
                        new_job_data.OrderTimestamp = "";
                        new_job_data.OrderBy = "";
                        new_job_data.OrderDate = 0;
                        new_job_data.CreationDate = Date.now();
                        new_job_data.QuoteParameters.DOCUMENTS = {
                            "3DScreenShots": [],
                        };
                        dispatch({
                            type: NEW_JOB,
                            parameter: new_job_data,
                        });
                        return resolve();
                    } else {
                        let error = await response.text();
                        return resolve("ERROR: " + error);
                    }
                })
                .catch((e) => {
                    return resolve("ERROR");
                });
        });
    };

export const updateJobStatus = async (jobId, businessCode, newStatus, statusTracking) => {
    const endPoint = API_BASE() + "job/" + jobId + "/?patch=true";

    await fetchTimeout(endPoint, {
        method: "PUT",
        body: JSON.stringify({
            id: jobId,
            BusinessCode: businessCode,
            Status: newStatus,
            StatusTracking: statusTracking,
        }),
    });
};

export const updateJobErp = (business_code, job_id, new_erp) => (dispatch) => {
    return new Promise((resolve) => {
        let job_url = API_BASE() + "job/" + business_code + "/" + job_id;
        fetchTimeout(job_url, {
            method: "POST",
            body: JSON.stringify({
                action: "replace",
                value: {
                    ErpNumbers: new_erp,
                },
            }),
        }).then(async (response) => {
            if (response.status >= 200 && response.status <= 300) resolve("OK");
            else resolve("ERROR");
        });
    });
};

export const updateJobHistory =
    ({ business_code, job_id, new_history }) =>
    (dispatch) => {
        return new Promise((resolve) => {
            let job_url = API_BASE() + "job/" + business_code + "/" + job_id;
            fetchTimeout(job_url, {
                method: "POST",
                body: JSON.stringify({
                    action: "update",
                    value: {
                        History: new_history,
                    },
                }),
            }).then(async (response) => {
                if (response.status >= 200 && response.status <= 300) resolve("OK");
                else resolve("ERROR");
            });
        });
    };

export const updateJobIfRequired =
    (updateSVGIfLocked = true) =>
    (dispatch, getState) => {
        const job = getState()?.job;
        if (!job) return;
        if (document.hidden) return;
        const job_ts = job._ts;
        const business_code = job.BusinessCode;
        const job_id = job.id;
        const user_data = getState().app?.user;

        return new Promise((resolve) => {
            let job_url = API_BASE() + "job/" + business_code + "/" + job_id;
            fetchTimeout(job_url, {
                method: "POST",
                body: JSON.stringify({
                    action: "getJobIfRequired",
                    job_ts: job_ts,
                    user_id: user_data.id,
                    session_id: window?.session_id,
                }),
            }).then(async (response) => {
                if (response && response?.status && response.status >= 200 && response.status <= 300) {
                    let text = await response.text();
                    if (text == "") {
                        resolve("OK, no need to update");

                        if (updateSVGIfLocked && job?.App?.Locked) {
                            let job_to_load = _cloneDeep(job);
                            job_to_load.App.current_SVG = null;
                            if (job.App.current_SVG === null) job_to_load.App.current_SVG = "";

                            dispatch({
                                type: NEW_JOB,
                                parameter: job_to_load,
                            });

                            dispatch({
                                type: UPDATE_DESIGNER,
                                parameter: SHOW_LOADING_BAR,
                                value: false,
                            });
                        }
                    } else {
                        let data = JSON.parse(text);

                        if (data?.Locked) {
                            let job_to_load = _cloneDeep(job);

                            job_to_load.App.Locked = true;
                            job_to_load.App.LockMessage = data.LockMessage;

                            dispatch({
                                type: NEW_JOB,
                                parameter: job_to_load,
                            });

                            dispatch({
                                type: UPDATE_DESIGNER,
                                parameter: SHOW_LOADING_BAR,
                                value: false,
                            });
                            return;
                        }
                        let job_to_load = _cloneDeep(data);

                        resolve("OK, update", job_to_load);
                        if (job?.["QuoteParameters"]?.["BOM"]) {
                            if (job_to_load?.["QuoteParameters"]) job_to_load["QuoteParameters"] = {};
                            job_to_load["QuoteParameters"]["BOM"] = COMMON.deepCopy(job["QuoteParameters"]["BOM"]);
                        }

                        if (updateSVGIfLocked && job_to_load?.App?.Locked) {
                            job_to_load.App.current_SVG = null;
                            if (job.App.current_SVG === null) job_to_load.App.current_SVG = "";
                        }

                        dispatch({
                            type: NEW_JOB,
                            parameter: job_to_load,
                        });

                        dispatch({
                            type: UPDATE_DESIGNER,
                            parameter: SHOW_LOADING_BAR,
                            value: false,
                        });
                    }
                } else resolve("ERROR");
            });
        });
    };

export const loadJob =
    (business_code, quote_id, user_data, db_mode = "") =>
    (dispatch, getState) => {
        checkInternetConnection(dispatch);
        window.loading_job_id = quote_id;
        return new Promise((resolve) => {
            let job_url = API_BASE() + "job/" + business_code + "/" + quote_id + "/" + db_mode;
            fetchTimeout(
                job_url,
                {
                    method: "GET",
                },
                45000
            )
                .then(async (response) => {
                    let documents = JSON.parse(await response.text());

                    window.loading_job_id = null;
                    if (documents.length > 0) {
                        //merge with template
                        let recall_job_data = { ...documents[0] };

                        let config = getState().config;

                        let app = getState().app;

                        let region = recall_job_data?.Distributor?.Offer?.Regions?.[0];
                        //
                        if (region && config && region !== config.id) {
                            // save this offering
                            let brand = recall_job_data?.Distributor?.Offer?.Brand;
                            let region_offering = recall_job_data?.Distributor?.Offer?.offerings?.[region];
                            if (!region_offering) region_offering = app?.offerings?.[brand]?.Regions?.[region];
                            if (region_offering) {
                                config = COMMON.mergeDeep(
                                    { ..._cloneDeep(app.offerings[brand].Master) },
                                    region_offering
                                );

                                let new_app_offering = { ...app.offerings };

                                new_app_offering[brand].Regions[region] = region_offering;
                                if (new_app_offering) dispatch(updateAPP("offerings", new_app_offering));

                                if (recall_job_data?.DesignParameters?.CustomisedOffering) {
                                    config = COMMON.mergeDeep(config, {
                                        ..._cloneDeep(recall_job_data?.DesignParameters?.CustomisedOffering),
                                    });
                                }

                                dispatch(CONFIG.updateConfigAll(config));
                            }
                        }

                        let user_data_for_validation = user_data;
                        if (recall_job_data?.User) user_data_for_validation = recall_job_data?.User;
                        if (!user_data_for_validation?.BusinessDetails && recall_job_data?.Distributor)
                            user_data_for_validation.BusinessDetails = recall_job_data?.Distributor;
                        let num_areas = recall_job_data?.AreaSpecifications.length;
                        let job_to_load = _cloneDeep(
                            newDefaultJobState(config, "", user_data_for_validation, num_areas ? num_areas : 1)
                        );

                        _merge(job_to_load, recall_job_data);

                        //reset values
                        window.svg = null;
                        window.svg_data = null;
                        job_to_load.App = {
                            current_SVG: "",
                            current_OBJ: "",
                            temp_POA: "",
                        };

                        if (job_to_load?.QuoteParameters?.BOM?.bomHashCode)
                            job_to_load.QuoteParameters.BOM.bomHashCode = 0;

                        if (config?.region?.id === region ? config : null)
                            job_to_load = JOBSTATE_VALIDATION.validateFullJob(config, job_to_load, -1, getState().app);

                        dispatch({
                            type: NEW_JOB,
                            parameter: job_to_load,
                        });

                        setTimeout(function () {
                            let warnings = JOBSTATE_VALIDATION.getWarnings(
                                job_to_load,
                                getState()?.app?.user,
                                getState()?.config
                            );

                            // Add warnings from warningsHelper
                            let standardErrors = jobStateErrorPopups({
                                config: getState()?.config,
                                job: job_to_load,
                                dispatch: () => null,
                                app: getState()?.app,
                            });

                            if (standardErrors?.length > 0) warnings["message"] = standardErrors.title;

                            if (warnings && warnings.warning)
                                dispatch({
                                    type: SHOW_DESIGNER_MESSAGE,
                                    message: warnings.message,
                                });
                        }, 2000);

                        return resolve(true);
                    } else {
                        throw new Error("No Job");
                    }
                })
                .catch((e) => {
                    console.error("Error loading job", e);

                    window.loading_job_id = null;
                    return resolve(false);
                    // handle errors and timeout error
                }); // parses JSON response into native Javascript objects
        });
    };

export const saveJob =
    (job = null) =>
    async (dispatch, getState) => {
        if (!job) job = { ...getState().job };
        if (!job) return null;

        const savejob_url = API_BASE() + "job/" + job.id;
        const save_job = { ...job, ErrorMap: {} };

        const user_data = getState().app?.user;
        if (user_data) {
            //&& !user_data.id.includes("diego.portela")) {
            save_job.LastEditor = {
                id: user_data.id,
                DisplayName: user_data.DisplayName,
                UserCode: user_data.UserCode,
                _session_id: window?.session_id,
                _ts: Date.now(),
            };
        }

        try {
            const response = await fetchTimeout(savejob_url, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(save_job),
            });

            // handle specific statuses
            if (response.status === 401) {
                const error = await response.text();
                const job_to_load = _cloneDeep(job);
                job_to_load.App = job_to_load.App || {};
                job_to_load.App.Locked = true;
                job_to_load.App.LockMessage = error;

                dispatch({ type: NEW_JOB, parameter: job_to_load });
                return { status: 401, message: error };
            }

            if (response.status === 422) {
                const error_map = await response.json();
                dispatch({ type: UPDATE_ERROR_MAP, value: error_map });
                return { status: 422, error_map };
            }

            if (response.status === 409) {
                const error = await response.text();
                dispatch({
                    type: SHOW_DESIGNER_MESSAGE,
                    message: { type: "error", message: error || "This job's material list changed elsewhere. Please reload before saving again." },
                });
                return { status: 409, message: error };
            }

            if (response.ok) {
                dispatch({ type: CLEAR_ERROR_MAP });

                // If server returns JSON, parse it (guard by content-type)
                const ct = response.headers.get("content-type") || "";
                let payload = null;
                if (ct.includes("application/json")) {
                    payload = await response.json();
                    // optional: update store with the server-returned job
                    if (payload?.job) {
                        dispatch({ type: NEW_JOB, parameter: payload.job });
                    }
                    // keep this session's known BOM timestamp current
                    if (payload?.bom_ts !== undefined) {
                        const current_bom = getState().job?.QuoteParameters?.BOM || {};
                        dispatch(
                            updateJobState(
                                UPDATE_QUOTE_PARAMETERS,
                                "BOM",
                                { ...current_bom, _ts: payload.bom_ts },
                                false
                            )
                        );
                    }
                }

                return { status: response.status, payload };
            }

            // other non-OK statuses
            const txt = await response.text().catch(() => "");
            return { status: response.status, text: txt };
        } catch (err) {
            // network / timeout error
            console.error("saveJob error:", err);
        }
    };
